<app-headnav [user]="userName" (info)="onInfo($event)" [logOutFlag]="logOutFlag" (getLogo)="onSavedLogo($event)">
</app-headnav>
<!--div class="task-box" cdkDrag *ngIf="expanded" [style.right.px]="taskBoxRight">
	<div class="row" style="background-color: rgb(28 36 51);  border-radius: 3px; padding-top: 0.375rem;
    padding-right: 0.375rem;
    padding-bottom: 0.375rem;
    padding-left: 0.375rem;
	border-right: 1px solid white;
    border-top: 1px solid white;
    border-left: 1px solid white;"
	>
		<span>
			<a style="cursor: pointer; color: white;" (click)="expandcollapse();" title="Expand/Collapse">
				<i *ngIf="!expanded" style="margin-left: 5px;  margin-bottom: 2px; vertical-align: middle;" class="fas fa-chevron-right" size="lg"></i>
				<i *ngIf="expanded" style="margin-left: 5px; margin-bottom: 2px; vertical-align: middle" class="fas fa-chevron-down" size="lg"></i>
			</a>
		</span>

		<span *ngIf="!expanded" style="font-size: 16px; margin-left:10px; color: white;">News
				Alert</span>
		<span *ngIf="expanded" style="font-size: 16px; margin-left:32%; color: white;">News
				Alert</span>
	</div>
	<div *ngIf="expanded" class="row">
		<iframe width="800px" height="800px" src="https://www.erisinfo.com/ca/">

		</iframe>
	</div>
</div>

<div class="task-box" *ngIf="!expanded" style="position:absolute; top: 10px" [style.right.px]="taskBoxRight"> 
	<div class="row" style="background-color: rgb(28 36 51);  border-radius: 3px; padding-top: 0.375rem;
    padding-right: 0.375rem;
    padding-bottom: 0.375rem;
    padding-left: 0.375rem;">
		<span>
			<a style="cursor: pointer; color: white;" (click)="expandcollapse();" title="Expand/Collapse">
				<i *ngIf="!expanded" style="margin-left: 5px;  margin-bottom: 2px; vertical-align: middle;" class="fas fa-chevron-right" size="lg"></i>
				<i *ngIf="expanded" style="margin-left: 5px; margin-bottom: 2px; vertical-align: middle;" class="fas fa-chevron-down" size="lg"></i>
			</a>
		</span>

		<span *ngIf="!expanded" style="font-size: 16px; margin-left:10px; color: white;">News
				Alert</span>
		<span *ngIf="expanded" style="font-size: 16px; margin-left:32%; color: white;">News
				Alert</span>
	</div>
	<div *ngIf="expanded" class="row">
		<iframe width="800px" height="800px" src="https://www.erisinfo.com/ca/">

		</iframe>
	</div>
</div-->
<div *ngIf="!userId" class="studio">
	<!--<div class="loading">
    <img src="assets/images/loader.gif" alt="spinner" width="64" height="64" />
    
  </div>-->
</div>
<div *ngIf="userId" class="studio">
  <section class="content">
		<div class="sidenav flex-container" [style.width]="sideNavWidth">
			<a href="#" title="Dashboard" >
			<!--span aria-hidden="true" data-icon="&#xe90a;" class="icon-dashboard" style="font-size:32px"></span-->
			<span aria-hidden="true" data-icon="&#xe90a;" class="icon-dashboard" style="font-size:32px">
			</span>
			<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Dashboard</span>

			</a>
			<!-- <a href="report" title="Report Writer" target=_blank><i class="far fa-edit"></i></a><i class="fas fa-tachometer-alt"></i> -->
			<a href="cover" title="Cover Page" target=_blank><i class="icon-Cover" style="font-size:32px"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Cover, Header & Footer</span>
			</a>
			<a href="template" title="Template" target=_blank><i class="icon-Template" style="font-size:32px"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Templates</span>

			</a>
			<a href="complete" title="Completed Reports" target=_blank>
				<i style="margin-left: 5px" class="far fa-list-alt"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Complete Reports</span>
			</a>
			<!--hr class="m-2" style="background:grey; z-index:9999999;"-->
			<a href="company" style="border-top: 1px solid #000000;" title="Company" target=_blank><i class="icon-property" style="font-size:32px"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Company Info</span>

			</a>
					
      <!--hr class="m-2" style="background:grey; z-index:9999999;"-->
			<a title="Libraries" href="resources" style="border-top: 1px solid #000000" target=_blank class="active">
        <span aria-hidden="true" data-icon="&#xe90f;" class="icon-Libraries" style="font-size:32px; margin-left:5px"></span>
        <span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Libraries</span>
      </a>

			<!--hr class="m-2" style="background:grey; z-index:9999999;"-->
			<a *ngIf="userInfo.ERIS_STAFF=='Y'" title="ERIS" href="erisonly" style="border-top: 1px solid #000000" target=_blank>
				<i  class="icon-eris" style="font-size: 32px;"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">ERIS Only</span>

				</a>

			<a  (click)="toggleSideBar()"> 

				<i *ngIf="!toggleSideBarVar" class="pi pi-chevron-right" style="font-size: 24px;"></i>
				<i  *ngIf="toggleSideBarVar"class="pi pi-chevron-left" style="font-size: 24px;"></i>

			</a>





			
		</div>

    <div class="tableView">
      <ul class="nav nav-tabs  nav-justified" style="background-color: rgb(9 17 33);">
        <li class="nav-item">
          <a class="nav-link active" data-toggle="tab" href="#Reports">Libraries</a>
        </li>
                <li class="nav-item">
          <a (click)="getAllPCA();"class="nav-link" data-toggle="tab" href="#costTable">Cost Table Library</a>
        </li>
        <li class="nav-item">
          <a (click)="getAllSlots();"class="nav-link" data-toggle="tab" href="#Portfolio">Repeat Fields</a>
        </li>
        <li class="nav-item">
          <a id="templatebutton" (click)="getCompanyTemplates(); getTemplateCounts();getTemplateTypeCategory(); "class="nav-link" data-toggle="tab" href="#templates">Company Templates</a>
        </li>
        <li class="nav-item">
          <a (click)="getAllCoverpages(); getAllHeaders(); getAllFooters(); "class="nav-link" data-toggle="tab" href="#Coverpage">Cover Page, Header, Footer</a>
        </li>

        <li class="nav-item">
          <a (click)="getAllWatermark();"class="nav-link" data-toggle="tab" href="#watermark">Watermarks</a>
        </li>
      </ul>
      <div class="tab-content">
        <div id="Reports" style="color:white" class="tab-pane active"><br>
			
          <p-table #pt styleClass="p-datatable-sm" [value]="libraryData" [columns]="cols" [scrollable]="true" scrollHeight="76vh"
         (onFilter)="setExcel($event)" [virtualScroll]="true" [virtualRowHeight]="20">
            <!--[paginator]="true" [rows]="250"  
              [scrollable]="true"
            scrollHeight="calc(100vh - 220px)" [virtualScroll]="true"
            -->
            <ng-template pTemplate="caption">

              <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
                <span>
                  {{totalLibraries}} Library Items
                  <a class="btn btn-sm btn-outline-light pt-0 pb-0 pl-1 pr-1 ml-4"
                    data-toggle="modal" data-target="#reportsModal" 
                    (click)="newLibrary=true; formCheck=false; clearLibraryForm();manageLibraryPermission=false;checkManageLibraryPermission(null); test();">
                    Add New Library Item</a>
                  <a class="btn btn-sm btn-outline-light pt-0 pb-0 pl-1 pr-1 ml-4"
                    data-toggle="modal" data-target="#import"
                    (click)="resetUpload();costUpload=false;manageLibraryPermission=false;checkManageLibraryPermission(null)">Upload Library</a>
                  <a class="btn btn-sm btn-outline-light pt-0 pb-0 pl-1 pr-1 ml-4" 
                  (click)="exportExcel();">Export Library</a>
                  <i *ngIf="loading" class="pi pi-spin pi-spinner"
                  style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>
                </span>
              
                <input type="text" pInputText placeholder="Search" style="background-color: rgb(28 36 51); padding: 3px; border: 0px; color: white"
                  (input)="pt.filterGlobal($event.target.value, 'contains')">

                <!-- 
                        <a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background:#58a400; color:white"
                          data-toggle="modal" data-target="#reportsModal" (click)="newClient=true;">

                          Add New Client
                        </a>
                        <a   class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background:#58a400; color:white" (click)="toggleClient()">
                          Toggle View
                        </a>
                      </span>
                      <input type="search" pInputText placeholder="Search"
                        (input)="dv2.filter($event.target.value, 'contains')"> -->
              </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>

              <tr style="font-size:12px">
                <th *ngFor="let col of columns; trackBy: trackByFuntion" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field">
                  {{col.header}}
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                <!--
                  <th *ngFor="let col of columns | slice:1:17; let i=index" style="padding:2px">
									<input *ngIf="col.field!='EDIT'" pInputText type="text"
										(input)="tt.filter($event.target.value, col.searchfield, 'contains')"
										style="margin:0 2px; font-size:12px; width:98%;">
								</th>
                -->
              </tr>

            </ng-template>
            <ng-template pTemplate="body" let-user let-i="rowIndex" let-columns="columns">
              <tr style="font-size:12px">
                <td *ngFor="let col of columns; trackBy: trackByFuntion" [ngStyle]="{'width': col.width}"  style="padding:4px; border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)">
                  <span *ngIf="col.field!='LABELS'&& col.field!='EDIT'">

                    <!-- <a class="info"
                                  (click)="user[col.field+'_EDIT']=true; user[col.field+'_TOEDIT']= user[col.field]; "
                                  *ngIf="!user[col.field+'_EDIT']"> -->
                    <span *ngIf="user[col.field]">{{user[col.field]}}&nbsp;</span>


                  </span>
				      <a *ngIf="col.field=='SHORT_CONTENT'" href="javascript:void(0)" class="float-md-right" title="Content Detail" (click)="op3.toggle($event);" ><i style="color: rgb(201 218 251)"
                  class="far fa-eye iconBtn"></i></a>
											<p-overlayPanel #op3 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true" [style]="{'width': '800px'}" (onShow)="getSftContent(user)">
												<ng-template pTemplate>
													<div style="margin: 10px; color:#ccc;max-height:400px; overflow:auto"> 
                            <h6>{{user.ITEM_TITLE}}</h6>
													<ng-container *ngFor="let label of user.LABELS.split(';')">
														<label class="tag">{{label}}</label>
													</ng-container>
													<div>
														<strong>Instruction : </strong>
														<span style="color:white">{{user.INSTRUCTIONS}}</span>
													</div>
													<div>
														<strong>Content : </strong>
														<span *ngIf="!user.CONTENT_HTML||user.CONTENT_HTML.length==0" style="color:white">{{user.CONTENT}}</span>
														<div *ngIf="user.CONTENT_HTML&&user.CONTENT_HTML.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="user.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></div>
                          </div>
														<!--<h4>Content</h4>
                          								<hr>
															<div>
															
															 <span *ngIf="!user.CONTENT_HTML||user.CONTENT_HTML.length==0" style="color:white">{{user.CONTENT}}</span>
															 <div *ngIf="user.CONTENT_HTML&&user.CONTENT_HTML.length>0" style="color:#222; background-color: #ccc; width:100%; padding:4px" [innerHTML]="user.htmltext?.changingThisBreaksApplicationSecurity|safeHtml"></div>
															</div>-->
														</div>
												</ng-template>
											</p-overlayPanel>
                  <span *ngIf="col.field=='EDIT'">
                      <a style="cursor:pointer;"
                        data-toggle="modal" data-target="#reportsModal" 
                        (click)="newLibrary=false; libraryToUpdate=user; fillLibrary(user);manageLibraryPermission=false;checkManageLibraryPermission(user.LIBRARY_ID);">
                      <i style="color: rgb(201 218 251)" class="fas fa-edit"></i></a>
 
                  </span>				 
                  <span *ngIf="col.field=='LABELS'">
                    <a style="float:right; cursor:pointer;"  *ngIf="user.ARRAYLABELS&&user.ARRAYLABELS.length>3" title="View All" (click)="user.SHOWALL=!user.SHOWALL;">
                      
                      <i *ngIf="!user.SHOWALL" class='fas fa-chevron-right'></i>
                      <i *ngIf="user.SHOWALL" class='fas fa-chevron-down'></i>
                      <!-- <p-overlayPanel #op2 [appendTo]="'body'" [style]="{'width':'400px'}" [dismissable]="true">
                        <div *ngFor="let label of user.ARRAYLABELS; let k=index">
                            <a (click)="removeLabel(user, k)" style="cursor:pointer; margin:3px"><i
                              class="erisGreen fas fa-times"></i></a>{{label}}
                             <label class="tag">{{label}}<i class="fas fa-times iconBtn" (click)='removeLabel(user, k)'></i></label>
                   
                        </div>
                      </p-overlayPanel> -->
                    </a>
                    <div *ngIf="user.LABELS&&user.LABELS.length>0">  
                    <div *ngFor="let label of user.ARRAYLABELS; let k=index; trackBy: trackByFuntion" style="max-width: 100%;">
                      <span *ngIf="k<3 || user.SHOWALL" [title]="label" style="word-wrap: break-word; white-space: wrap; text-overflow: ellipsis;">
                        <a (click)="removeLabel(user, k)" style="cursor:pointer; margin:3px; color: rgb(201 218 251)
                        "><i
                          class="fas fa-times"></i></a>{{label}}
                      </span>
                          <!-- <label class="tag">{{label}}<i class="fas fa-times iconBtn" (click)='removeLabel(user, k)'></i></label> -->
               
                    </div>

                  </div>
                    <!--<a style="cursor:pointer; margin:3px" (click)="op1.toggle($event); user.SHOWALL=true; user.toAddLabel2=''"><i
                        class="erisGreen1 fas fa-plus"></i></a>
                    <p-overlayPanel my="right" at="left"  (onHide)="user.SHOWALL=false;" #op1 [appendTo]="'body'" [style]="{'width':'400px'}" [dismissable]="true" [draggable]="true">
                      Choose From Exisiting Identifiers:
                      <ng-select class="p-1 rptInfo" style="margin:4px; background-color: white;" [clearable]="false" [items]="allLabels"
                        notFoundText="Not Found" bindLabel="LABEL" bindValue="LABEL" [(ngModel)]="user.toAddLabel1"
                        (change)="addLabel(user, 1);">
                       
                      </ng-select>
                      Add New Identifier: <br>
                      <input class="p-1 rptInfo" type="text" style="width:280px; margin:4px; background-color: white;" placeholder="separate your identifier by ;" [(ngModel)]="user.toAddLabel2"> <a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background:#C2D63F; color:black" (click)='addLabel(user, 2); '>Add</a>
                    </p-overlayPanel>-->
                  </span>

                  <span *ngIf="col.field=='STATUS'">
                    <!-- {{user.STATUS}} -->
                    <a title="Change status" style="cursor:pointer; float:right" *ngIf="user.STATUS=='Active'"
                      (click)=changeLibraryStatus(user)>
                      <i class="erisIconColor fas fa-toggle-on"></i>
                    </a>
                    <a title="Change status" style="cursor:pointer; float:right" *ngIf="user.STATUS!='Active'"
                      (click)=changeLibraryStatus(user)>
                      <i class="erisIconColor fas fa-toggle-off"></i>
                    </a>
                    </span>

                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        
        <div id="Portfolio" style="color:white" class="tab-pane fade"><br>
          <p-table #py styleClass="p-datatable-sm" [value]="allSlots" [columns]="slotCols" [paginator]="true" [rows]="50" >
            <ng-template pTemplate="caption">
              <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
                <span>
                  {{totalSlots}} Repeat Fields
                  <a class="btn btn-sm btn-outline-light pt-0 pb-0 pl-1 pr-1 ml-4"
                    data-toggle="modal" data-target="#reportsModal2"
                    (click)="showRepeatFields();manageRepeatFieldPermission = false; getSlotPara(); getslotType(); checkManageRepeatFieldPermission(null)"> Add New Repeat Field</a>
                    <i *ngIf="slotLoading" class="pi pi-spin pi-spinner"
                    style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>
                </span> 

				<input #file3 type="file" style="display: none;" (change)="uploadFile1()" accept=".xlsx,.csv">
	            <input type="text" pInputText placeholder="Search" style="background-color: rgb(28 36 51); padding: 3px; border: 0px; color: white"
                  (input)="py.filterGlobal($event.target.value, 'contains');consoleLog(py.filteredValue);filteredArray(py.filteredValue)">
                <!-- 
                            <a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background:#58a400; color:white"
                              data-toggle="modal" data-target="#reportsModal" (click)="newClient=true;">
    
                              Add New Client
                            </a>
                            <a   class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background:#58a400; color:white" (click)="toggleClient()">
                              Toggle View
                            </a>
                          </span>
                          <input type="search" pInputText placeholder="Search"
                            (input)="dv2.filter($event.target.value, 'contains')"> -->
              </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>

              <tr style="font-size:12px">
                <th *ngFor="let col of columns; trackBy: trackByFuntion" [ngStyle]="{'width': col.width}" style="padding:1px; font-size:11px" [pSortableColumn]="col.field">
                  {{col.header}}
                  <p-sortIcon *ngIf="col.field!='EDIT'" [field]="col.field"></p-sortIcon>

              </tr>


              <tr>
                <th *ngFor="let col of columns; let i=index; trackBy: trackByFuntion" style="padding:2px">
                  <input *ngIf="i!=5 && i!=4" class="inputHeader" pInputText type="text"
                    (input)="py.filter($event.target.value, col.field, 'contains')"
                    style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px">
                  
                  <!-- <input *ngIf="i==0" pInputText type="text"
                              (input)="tt.filter($event.target.value, 'flat', 'projectnumname')"
                              style="margin:0 2px; font-size:12px; width:98%;"> -->
                  <select class="inputHeader ml-1"  style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px" *ngIf="col.field=='STATUS'" [(ngModel)]="selectedFilter4" (change)="filterTemplates4(selectedFilter4)">
                    <option [ngValue]="''">
            
                    </option>
                    <option [ngValue]="'Active'">
            
                      Active
                    </option>
                    <option [ngValue]="'Inactive'">
            
                      Inactive
                      </option>
                    </select>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user let-i="rowIndex" let-columns="columns">
              <tr style="font-size:12px">
                <td *ngFor="let col of columns; trackBy: trackByFuntion" [ngStyle]="{'width': col.width}" style="padding:4px; border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)">
                  <span *ngIf="col.field!='CONTENT'&& col.field!='SYSTEM_CUSTOMIZE' && col.field!='STATUS'"class="line-clamp1" style="float:left">{{user[col.field]}} </span>
                 <!-- <span *ngIf="col.field=='SYSTEM_IND'">{{user.SYSTEM_IND=='Y'? 'System':'Customize'}} </span>-->
                 
                 <span *ngIf="col.field=='STATUS'"> <!--status here-->
                  {{user.STATUS}}
                  <a title="Change status" style="cursor:pointer; float:right" *ngIf="user.STATUS=='Active'"
                    (click)=changeStatus(user)>
                    <i class="erisIconColor fas fa-toggle-on"></i>
                  </a>
                  <a title="Change status" style="cursor:pointer; float:right" *ngIf="user.STATUS!='Active'"
                    (click)=changeStatus(user)>
                    <i class="erisIconColor fas fa-toggle-off"></i>
                  </a>
                  </span>

                  <span *ngIf="col.field=='SYSTEM_CUSTOMIZE'">{{user.SYSTEM_CUSTOMIZE}} </span>
				  <span *ngIf="col.field=='CONTENT'">
                   <span style="float:left" #check>
                    <span *ngIf="(user.TYPE!='Table')&&(user.TYPE!='Selection')&&(user.TYPE!='File')">{{user.CONTENT}}</span>
                    <div *ngIf="user.TYPE=='File'&&user.ERIS_FILE!='Y'">
						<a [href]="user.CONTENT" target=_blank style="color:#C2D63F">{{user.FILE_NAME}}</a>
                    </div>
					<div *ngIf="user.TYPE=='Selection'">
					{{user.CONTENT}}
                      <!--<ng-container *ngFor="let item of user.tableContent; let i=index; trackBy: trackByFuntion">
                        <span *ngIf="i<3">. {{item}}</span><br *ngIf="i<3">
                      </ng-container>-->
                    </div>	
                    <div *ngIf="user.TYPE=='Table'">
                      <table  style="padding:1px; font-size:11px" [pSortableColumn]="col.field" style="width:90%; border: 1px solid black;  border-collapse: collapse;">
                      <thead>
                        <tr>
                        <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">No.</th>
                        <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Name</th>
                        <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngFor="let item of user.tableContent; let i=index; trackBy: trackByFuntion">
                          <tr *ngIf="i<3">
                          <td style="padding:1px; font-size:11px" [pSortableColumn]="col.field">{{i}}</td>
                          <td style="padding:1px; font-size:11px" [pSortableColumn]="col.field">{{item.NAME}}</td>
                          <td style="padding:1px; font-size:11px" [pSortableColumn]="col.field">{{item.TYPE}}</td>
                          </tr>
                        </ng-container>
                      </tbody>
                      </table>
                    </div>
                  
                  </span> 
                    <a *ngIf="user.CONTENT?.length>0||user.TYPE=='Selection'" href="javascript:void(0)" style="width:5%; margin-top:2px; float:right" title="Content" (click)="op11.toggle($event);" ><i style="color:rgb(201,218,251)"class="fas fa-eye"></i></a>					
                    <p-overlayPanel #op11 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '400px'}" (onShow)="getTable(user)">
                                                  <ng-template pTemplate>
                                                      <div style="margin: 10px; color:#C2D63F;max-height:400px; overflow:auto; font-size:.9em"> 
                            <strong>{{user.KEY}}</strong>
                            <hr>
                              <strong>Content :</strong><br>
                              <span *ngIf="(user.TYPE!='Table')&&(user.TYPE!='File')">{{user.CONTENT}}</span>
							  <a *ngIf="user.TYPE=='File'" [href]="user.CONTENT" style="color:#C2D63F; width:100%; word-break:break-all" target=_blank >{{user.FILE_NAME}}</a>	
                              <div *ngIf="user.TYPE=='Selection'">
                                <strong>Options</strong>
								<span *ngIf="user.MULTIPLE_CHOICE=='Y'" style="font-size:.8em"> ( Multiple  Seleciton )</span><span *ngIf="user.MULTIPLE_CHOICE=='N'"  style="font-size:.8em"> ( Single Seleciton ) </span><br>
														<br>
                                <ng-container *ngFor="let item of tableContent; trackBy: trackByFuntion">
                                  <span>. {{item}}</span><br>
                                </ng-container>
                              </div>	
                              <div *ngIf="user.TYPE=='Table'">
                                <strong>Headers of Table</strong>
                                <table  style="padding:1px; font-size:11px" [pSortableColumn]="col.field" style="width:90%; border: 1px solid black;  border-collapse: collapse;">
                                <thead>
                                  <tr>
                                  <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">No.</th>
                                  <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Name</th>
                                  <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Type</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <ng-container *ngFor="let item of tableContent; let i=index; trackBy: trackByFuntion">
                                    <tr>
                                    <td style="padding:1px; font-size:11px" [pSortableColumn]="col.field">{{i}}</td>
                                    <td style="padding:1px; font-size:11px" [pSortableColumn]="col.field">{{item.NAME}}</td>
                                    <td style="padding:1px; font-size:11px" [pSortableColumn]="col.field">{{item.TYPE}}</td>
                                    </tr>
                                  </ng-container>
                                </tbody>
                                </table>
                              </div>
                            </div>
                                                  </ng-template>
                      </p-overlayPanel>
                  </span>
                  <span *ngIf="col.field=='EDIT'">
                    <span *ngIf="user.SYSTEM_IND!='Y'"style="cursor:pointer;">
                                       
                      <!--a data-toggle="modal" data-target="#deleteModal2"(click)="slotToDelete=user; deleteSlotIndex=i;" title="Delete Field" style="cursor:pointer;" class="mr-1">
                        <i class="erisGreen1 fas fa-trash"> </i>
                      </a-->
                      <a style="cursor: pointer; text-decoration: underline;" data-toggle="modal"
                      data-target="#reportsModal2"
                      (click)="resetSlotForm(); fillSlotForm(user); newSlot=false; updateSlotIndex=i; slotToUpdate=user; getRowIndex(i); getSlotPara(); getslotType();
                              manageRepeatFieldPermission = false; checkManageRepeatFieldPermission(user.SLOT_ID)">
                      <i class="fas fa-edit erisIconColor"></i></a>
                    </span>
  
                  </span>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>

        <div id="Coverpage" style="color:white; background-color: rgb(9 17 33)" class="tab-pane fade"><br>          
            <div class="row">         
              <div class='col-md-4'>
          <p-table #tt styleClass="p-datatable-sm" [value]="allCoverPages" [columns]="coverpageCols" [scrollable]="true"
            scrollHeight="calc(100vh - 250px)">
            <ng-template pTemplate="caption">

              <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
                <span style="font-size:.9em">
                  Cover Page ({{allCover}})
                  <!-- disable upload for now: -->
                  <!-- <a disabled class="btn btn-sm btn-outline-light pt-0 pb-0 pl-1 pr-1 ml-4" 
                    data-toggle="modal" data-target="#uploadHF" (click)="uploadtype='Coverpage'"> Upload New Coverpage</a> -->
                </span>
                <span>

                <input type="text" pInputText placeholder="Search"  size="16" style="background-color: rgb(28 36 51); padding: 3px; border: 0px; color: white"
                  (input)="tt.filterGlobal($event.target.value, 'contains')">
                </span>
              </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>

              <tr style="font-size:12px">
                <th *ngFor="let col of columns; trackBy: trackByFuntion" [ngStyle]="{'width': col.width}" style="padding:1px; font-size:11px" [pSortableColumn]="col.field">
                  {{col.header}}
                  <p-sortIcon [field]="col.field"></p-sortIcon>

              </tr>
              <tr> 
                <th *ngFor="let col of columns; let i=index; trackBy: trackByFuntion" style="padding:2px">
                  <input *ngIf="col.field!='CATEGORY_NAME' && col.field!='SUBCATEGORY_NAME'" class="inputHeader" pInputText type="text"
                    (input)="tt.filter($event.target.value, col.field, 'contains')"
                    style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px">
                    
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user let-i="rowIndex" let-columns="columns">
              <tr style="font-size:12px">
                <td *ngFor="let col of columns; trackBy: trackByFuntion" [ngStyle]="{'width': col.width}" style="padding:4px; border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)">
                  <div *ngIf="col.field=='COVERPAGE_TITLE'" class="row">
                    <a target="_blank" class="col-md-9" [href]="'/cover/Cover-' +user.COVERPAGE_ID" style="color:rgb(195,212,47)"> {{user[col.field]}}</a>
                    <a title="Delete" class="mr-1"  (click)="deleteFile(user)" href="javascript:void(0)" style="color:rgb(195,212,47); float:right"> <i class="fas fa-trash"></i></a>
                    <a title="Preview" class="mr-1" target="_blank" [href]="user.COVERPAGE_URL" style="color:rgb(195,212,47); float:right"> <i class="fas fa-search"></i></a>
				  </div>
                  <span class="line-clamp1" *ngIf="col.field!='COVERPAGE_TITLE' && col.field!='TEMPLATE_TITLE'&&col.field!='DATE_UPDATED'" style="float:left">{{user[col.field]}} </span>
                  
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>

        <div class='col-md-4'>

          <p-table #tt styleClass="p-datatable-sm" [value]="allHeaders" [columns]="headerCols" [scrollable]="true"
            scrollHeight="calc(100vh - 250px)">
            <ng-template pTemplate="caption">

              <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
                <span style="font-size:.9em">
                  
                  Headers&nbsp;({{allHead}})
                  <!-- <a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background:#58a400; color:white"
                    data-toggle="modal" data-target="#reportsModal2" (click)="newSlot=true;"> Add New Repeat Field</a> -->

                  <!-- disable upload for now: -->
                  <!-- <a class="btn btn-sm btn-outline-light pt-0 pb-0 pl-1 pr-1 ml-4" size='16'
                  data-toggle="modal" data-target="#uploadHF" (click)="uploadtype='Header'"> Upload New Header</a> -->
                </span>
                <span>

                <input type="text" pInputText placeholder="Search" style="background-color: rgb(28 36 51); padding: 3px; border: 0px; color: white"
                  (input)="tt.filterGlobal($event.target.value, 'contains')">
                </span>
              </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>

              <tr style="font-size:12px">
                <th *ngFor="let col of columns; trackBy: trackByFuntion" [ngStyle]="{'width': col.width}" style="padding:1px; font-size:11px" [pSortableColumn]="col.field">
                  {{col.header}}
                  <p-sortIcon [field]="col.field"></p-sortIcon>

              </tr>
              <tr> 
                <th *ngFor="let col of columns; let i=index; trackBy: trackByFuntion" style="padding:2px">
                  <input *ngIf="col.field!='CATEGORY_NAME' && col.field!='SUBCATEGORY_NAME'" class="inputHeader" pInputText type="text"
                    (input)="tt.filter($event.target.value, col.field, 'contains')"
                    style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px">
                    
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user let-i="rowIndex" let-columns="columns">
              <tr style="font-size:12px">
                <td *ngFor="let col of columns; trackBy: trackByFuntion" [ngStyle]="{'width': col.width}" style="padding:4px; border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)">
                  <span *ngIf="col.field=='HF_TITLE'">
                    <a target="_blank"[href]="'/cover/Header-' +user.HEADERFOOTER_ID" style="color:rgb(195,212,47)"> {{user[col.field]}}</a>
          <a title="Preview" target="_blank"[href]="user.HF_URL" style="color:rgb(195,212,47); float:right"> <i class="erisGreen1 fas fa-search"></i></a>
					<a title="Delete" class="mr-1"  (click)="deleteFile(user)" href="javascript:void(0)" style="color:rgb(195,212,47); float:right"> <i class="erisGreen1 fas fa-trash"></i></a>

        </span>
                  <span class="line-clamp1" *ngIf="col.field!='HF_TITLE' && col.field!='TEMPLATE_TITLE'&&col.field!='DATE_UPDATED'" style="float:left">{{user[col.field]}} </span>
                  
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <div class='col-md-4'>

          <p-table #tt styleClass="p-datatable-sm" [value]="allFooters" [columns]="footerCols" [scrollable]="true"
            scrollHeight="calc(100vh - 250px)">
            <ng-template pTemplate="caption">

              <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
                <span style="font-size:.9em">
                  
                  Footers ({{allFoot}})
                  <!-- <a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background:#58a400; color:white"
                    data-toggle="modal" data-target="#reportsModal2" (click)="newSlot=true;"> Add New Repeat Field</a> -->
                  
                  <!-- disable upload for now: -->
                    <!-- <a class="btn btn-sm btn-outline-light pt-0 pb-0 pl-1 pr-1 ml-4" size="16"
                    data-toggle="modal" data-target="#uploadHF" (click)="uploadtype='Footer'"> Upload New Footer</a> -->
                </span>
                <span>

                <input type="text" pInputText placeholder="Search"
                  (input)="tt.filterGlobal($event.target.value, 'contains')" style="background-color: rgb(28 36 51); padding: 3px; border: 0px; color: white">
                </span>
              </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>

              <tr style="font-size:12px">
                <th *ngFor="let col of columns; trackBy: trackByFuntion" [ngStyle]="{'width': col.width}" style="padding:1px; font-size:11px" [pSortableColumn]="col.field">
                  {{col.header}}
                  <p-sortIcon [field]="col.field"></p-sortIcon>

              </tr>
              <tr> 
                <th *ngFor="let col of columns; let i=index; trackBy: trackByFuntion" style="padding:2px">
                  <input *ngIf="col.field!='CATEGORY_NAME' && col.field!='SUBCATEGORY_NAME'" class="inputHeader" pInputText type="text" 
                    (input)="tt.filter($event.target.value, col.field, 'contains')"
                    style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px">
                    
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user let-i="rowIndex" let-columns="columns">
              <tr style="font-size:12px">
                <td *ngFor="let col of columns; trackBy: trackByFuntion" [ngStyle]="{'width': col.width}" style="padding:4px; border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)"> 
                  <span *ngIf="col.field=='HF_TITLE'">
                    <a target="_blank"[href]="'/cover/Footer-' +user.HEADERFOOTER_ID" style="color:rgb(195,212,47)"> {{user[col.field]}}</a>
                    <a title="Preview" target="_blank"[href]="user.HF_URL" style="color:rgb(195,212,47); float:right"> <i class="erisGreen1 fas fa-search"></i></a>
					<a title="Delete" (click)="deleteFile(user)" class="mr-1" href="javascript:void(0)" style="color:rgb(195,212,47); float:right"> <i class="erisGreen1 fas fa-trash"></i></a>
                  </span>
                  <span class="line-clamp1" *ngIf="col.field!='HF_TITLE' && col.field!='TEMPLATE_TITLE'&&col.field!='DATE_UPDATED'" style="float:left">{{user[col.field]}} </span>
                  
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>

        
        </div>
        </div>
        
        <div id="costTable" style="color:white" class="tab-pane fade"><br>
          <p-table #pt2 styleClass="p-datatable-sm" [value]="allPCA" [columns]="pcaCols"   
          [paginator]="true" [rows]="50" (onFilter)="setExcel($event)">
            <!--
              [scrollable]="true"
            scrollHeight="calc(100vh - 220px)"
            -->
            <ng-template pTemplate="caption">

              <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
                <span>
                  {{totalPCA}} Cost
                  <a class="btn btn-sm btn-outline-light pt-0 pb-0 pl-1 pr-1 ml-4"
                    data-toggle="modal" data-target="#costLibraryModal" (click)="newCostLibrary=true; resetCostLibrary(); formCheck=false; getCostUnit(); getCostLabels(); checkManageLibraryPermission(null);"> Add New Cost</a>
                    <a class="btn btn-sm btn-outline-light pt-0 pb-0 pl-1 pr-1 ml-4" 
                    data-toggle="modal" data-target="#import" (click)="resetUpload(); costUpload=true; checkManageLibraryPermission(null);" > Upload Cost Library</a>
                    <a class="btn btn-sm btn-outline-light pt-0 pb-0 pl-1 pr-1 ml-4" 
                    (click)="exportCostExcel();"> Export Cost Library</a>
                    <i *ngIf="loading" class="pi pi-spin pi-spinner"
							      style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>
                </span>
              
                <input type="text" pInputText placeholder="Search" style="background-color: rgb(28 36 51); padding: 3px; border: 0px; color: white"
                  (input)="pt2.filterGlobal($event.target.value, 'contains')">

              </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>

              <tr style="font-size:12px">
                <th [pSortableColumn]="col.field" *ngFor="let col of columns; trackBy: trackByFuntion" [ngStyle]="{'width': col.width}">
                  {{col.header}}
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
                
              </tr>
              <!--<tr>
                <th *ngFor="let col of columns" >
                  <p-columnFilter *ngIf="col.field!='EDIT' && col.field!='EUL' && col.field!='COST'" type="text" [field]="col.field"> </p-columnFilter>
                </th>
              </tr>-->
            </ng-template>
            <ng-template pTemplate="body" let-user let-i="rowIndex" let-columns="columns">
              <tr style="font-size:12px">
                <td *ngFor="let col of columns; trackBy: trackByFuntion" [ngStyle]="{'width': col.width}" style="padding:4px; border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)">
                  <span *ngIf="col.field!='IDENTIFIERS'&& col.field!='EDIT'">


                    <span *ngIf="user[col.field]">{{user[col.field]}}&nbsp;</span>


                  </span>

                  <span *ngIf="col.field=='STATUS'"> <!--status here-->
                    <a title="Change status" style="cursor:pointer; float:right" *ngIf="user.STATUS=='Active'"
                      (click)=changeStatusCost(user)>
                      <i class="erisIconColor fas fa-toggle-on"></i>
                    </a>
                    <a title="Change status" style="cursor:pointer; float:right" *ngIf="user.STATUS!='Active'"
                      (click)=changeStatusCost(user)>
                      <i class="erisIconColor fas fa-toggle-off"></i>
                    </a>
                    </span>

                  <span *ngIf="col.field=='EDIT'">
                      <!--a 													data-toggle="modal"
                      data-target="#deleteModalPCA" (click)="deleteUser=user; deleteIndex=i; checkManageLibraryPermission(null);" title="Delete Library" style="cursor:pointer;" class="mr-1">
                        <i class="erisIconColor fas fa-trash"> </i>
                      </a--> 
                      <a style="cursor:pointer;"
                        data-toggle="modal" data-target="#costLibraryModal"
                        (click)="newCostLibrary=false; costlibraryToUpdate=user; fillCostLibrary(user); getCostUnit(); getCostLabels(); checkManageLibraryPermission(null);">
                        <i class="fas fa-edit erisIconColor"></i></a>
 
                  </span>
                  <span *ngIf="col.field=='IDENTIFIERS'">
                    <a style="float:right; cursor:pointer;"  *ngIf="user.ARRAYLABELS&&user.ARRAYLABELS.length>3" title="View All" (click)="user.SHOWALL=!user.SHOWALL;">
                      
                      <i *ngIf="!user.SHOWALL" class='fas fa-chevron-right'></i>
                      <i *ngIf="user.SHOWALL" class='fas fa-chevron-down'></i>

                    </a>
                    <div *ngIf="user.IDENTIFIERS"> 
                    <div *ngFor="let label of user.ARRAYLABELS; let k=index; trackBy: trackByFuntion">
                      <span *ngIf="k<3 || user.SHOWALL" [title]="label" style="word-wrap: break-word; white-space: wrap; text-overflow: ellipsis;">
                        <a (click)="removeLabelPCA(user, k)" style="cursor:pointer; margin:3px;  color: rgb(201 218 251)"><i
                          class="fas fa-times"></i></a>{{label}}
                      </span>
       
               
                    </div>

                  </div>
                    <!--<a style="cursor:pointer; margin:3px" (click)="op1.toggle($event); user.SHOWALL=true; user.toAddLabel2=''"><i
                        class="erisGreen1 fas fa-plus"></i></a>
                    <p-overlayPanel (onHide)="user.SHOWALL=false;" #op1 [appendTo]="'body'" [style]="{'width':'400px'}" [dismissable]="true">
                      Choose From Exisiting Identifiers:
                      <ng-select class="p-1 rptInfo" style="margin:4px; background-color: white;" [clearable]="false" [items]="allLabels"
                        notFoundText="Not Found" bindLabel="LABEL" bindValue="LABEL" [(ngModel)]="user.toAddLabel1"
                        (change)="addLabelPCA(user, 1);">
                        
                      </ng-select>
                      Add New Identifier: <br>
                      <input class="p-1 rptInfo" type="text" style="width:280px; margin:4px; background-color: white;" placeholder="separate your identifier by ;" [(ngModel)]="user.toAddLabel2"> <a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background:#C2D63F; color:black" (click)='addLabelPCA(user, 2);'>Add</a>
                    </p-overlayPanel>-->
                  </span>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <div id="watermark" style="color:white" class="tab-pane fade"><br>
          <!-- <p-table #pt3 styleClass="p-datatable-sm" [value]="allWatermarks" [columns]="watermarkCols" [scrollable]="true"
            scrollHeight="calc(100vh - 220px)">
            <ng-template pTemplate="caption">

              <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
                <span>
                  Watermarks
                  <a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background:#58a400; color:white"
                  data-toggle="modal" data-target="#watermarkForm" (click)="watermarkEdit=false" > Add New Watermark</a>
                </span>
              
                <input type="search" pInputText placeholder="Search"
                  (input)="pt3.filterGlobal($event.target.value, 'contains')">

              </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>

              <tr style="font-size:12px">
                <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}">
                  {{col.header}}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user let-i="rowIndex" let-columns="columns">
              <tr style="font-size:12px">
                <td *ngFor="let col of columns" [ngStyle]="{'width': col.width}">
                  <span *ngIf="col.field!='WM_TITLE'&& col.field!='text'">

                    <span *ngIf="user[col.field]">{{user[col.field]}}&nbsp;</span>

                    
                  </span>
                  <span *ngIf="col.field=='WM_TITLE'">
                    <a style="color:rgb(195,212,47)" target="_blank" [href]="user.pdf_url"> {{user.WM_TITLE}} </a>
                    </span>
                  <span *ngIf="col.field=='text'">
                    <span [style.color]="user.color" [style.font-size]="user.fontsize +'px'" [style.font-family]="user.fontname"> {{user.text}} </span>
                  
                  </span>
                  <span *ngIf="col.field=='EDIT'">
                    <a style="cursor:pointer"  data-target='#deleteWatermarkConfirm' data-toggle="modal" (click)="watermarkToEdit=user;">
                    <i class="fas fa-trash erisGreen"></i></a>
                    <a style="cursor:pointer" class="ml-1"   data-target='#watermarkForm' data-toggle="modal" (click)="watermarkToEdit=user; watermarkEdit=true; fillWatermark()">
                      <i class="fas fa-edit erisGreen"></i></a>
                    
                  </span>
                </td>
              </tr>
            </ng-template>
          </p-table> -->
          <!--
            *ngIf="allWatermarks"
          -->
          <p-dataView        filterBy="WM_TITLE,CITY,text,position,DATE_CREATED,CREATED_BY"   #pt3  [value]="allWatermarks" [paginator]="true" [rows]="9" layout="grid"
          >
          <ng-template pTemplate="header">

            <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
              <span *ngIf="allWatermarks.length>1 || allWatermarks.length==0">
                {{allWatermarks.length}} Watermarks
                <a class="btn btn-sm btn-outline-light pt-0 pb-0 pl-1 pr-1 ml-4"  
                data-toggle="modal" data-target="#watermarkForm" (click)="checkAddWatermarkPermission(); watermarkEdit=false; watermarkWarn=false; resetWatermark()" > Add New Watermark</a>
              </span>
              <span *ngIf="allWatermarks.length==1">
                {{allWatermarks.length}} Watermark
                <a class="btn btn-sm btn-outline-light pt-0 pb-0 pl-1 pr-1 ml-4" 
                data-toggle="modal" data-target="#watermarkForm" (click)="checkAddWatermarkPermission(); watermarkEdit=false; watermarkWarn=false; resetWatermark()" > Add New Watermark</a>
              </span>
              <input type="text" pInputText placeholder="Search" style="background-color: rgb(28 36 51); padding: 3px; border: 0px; color: white"
                (input)="pt3.filter($event.target.value, 'contains')">

            </div>
          </ng-template>
          <ng-template let-user let-i="rowIndex" pTemplate="gridItem">
            <!-- <div class="p-col-12 p-md-3">
                            {{user.USER_ID}} test
                        </div> -->
            <div class="p-col-12 p-md-3">
              <div class="product-grid-item card"
                [style.background-color]="'rgb(28 36 51)'"
                style="padding:1rem;  margin-bottom:0rem; border:2px solid rgb(9 17 33)  ;">
                <div class="mb-2"
                  style="  font-weight: 600; border-bottom:rgb(9 17 33) 1px solid; color:white; margin:-1rem; padding:0.5rem">
                  <div class="row">
                    <div class="col-md-2">
                      <a style="cursor:pointer;"  data-target='#deleteWatermarkConfirm' data-toggle="modal" (click)="watermarkToEdit=user;">
                        <i class="fas fa-trash"  style="pointer-events:none"></i></a>
                    </div>
                    <div class="col-md-8 text-center">
                      <div *ngIf="user.WM_TITLE">{{user.WM_TITLE}}</div>
                      <div *ngIf="!user.WM_TITLE">Title Required</div>
                    </div>
                    <div class="col-md-2" >

                        <a style="cursor:pointer" class="ml-1"   data-target='#watermarkForm' data-toggle="modal" (click)="checkEditWatermarkPermission(); watermarkToEdit=user; watermarkEdit=true; fillWatermark();watermarkWarn=false">
                          <i class="fas fa-edit" style="pointer-events:none; color: rgb(201 218 251)"></i></a>
                    </div>
                  </div>
                </div>
                <!-- <div class="product-grid-item-content">
                              <div *ngIf="user.FULL_NAME" class="product-name">{{user.FULL_NAME}}</div>
                               <div *ngIf="!user.FULL_NAME" class="product-name">Name Required</div>
                              <div class="product-description">{{user.USER_EMAIL}}</div>
                            </div> -->
                <div [style.color]="'dedede'">

                  Watermark Text: <br><span class="ml-3">{{user.text}} </span>
                  <!--<div style="margin-left:15px">
                    <a style="font-weight:400" [exclude]="'.text'" (clickOutside)="user.text_EDIT=false;"
                    (click)="user.text_EDIT=true; user.text_TOEDIT= user.text"
                    [hidden]="user.text_EDIT">
                    <span [style.color]="user.color" [style.font-family]="user.fontname"> {{user.text}} </span>
                   
                  </a>
                  <span [hidden]="!user.text_EDIT">

                    <input [style.color]="user.color" [style.font-size]="user.fontsize +'px'" [style.font-family]="user.fontname" (change)="changeUserDetails('text', user);user.text_EDIT=false"
                      class="text editBox" type="text" pInputText [(ngModel)]="user.text_TOEDIT">
                  </span>
                  <br>
                  </div>-->
				  <br>
                  Color: <br><span class="ml-3"> {{user.color}} </span><i class="fas fa-square-full" [style.color]="user.color" style="outline:1px solid #ccc"></i>
                 <!-- <div style="margin-left:15px">
                    <a style="font-weight:400" [exclude]="'.color'" (clickOutside)="user.color_EDIT=false;"
                    (click)="user.color_EDIT=true; user.color_TOEDIT= user.color"
                    [hidden]="user.color_EDIT">
                    <span> {{user.color}} </span>
					<i class="fas fa-square-full" [style.color]="user.color"></i>
                  </a>
                  <span [hidden]="!user.color_EDIT" >
                    <input (colorPickerClose)="user.color_TOEDIT=user.color; changeUserDetails('color', user);user.color_EDIT=false "     (change)="changeUserDetails('color', user);user.color_EDIT=false" class="form-control validate rptInfo color editBox" [cpOutputFormat]="'rgba'" 
                    [(colorPicker)]="user.color" [(ngModel)]="user.color"/>

                  </span>
                  <br>
                  </div>-->
                  
                  <br>
                  Position: <br><span class="ml-3">{{user.position}} </span>
                 <!-- <div style="margin-left:15px">
                    <a style="font-weight:400" [exclude]="'.position'" (clickOutside)="user.position_EDIT=false;"
                    (click)="user.position_EDIT=true; user.position_TOEDIT= user.position"
                    [hidden]="user.position_EDIT">
                    <span > {{user.position}} </span>
                  
                  </a>
                  <span [hidden]="!user.position_EDIT">
                    <select     (change)="changeUserDetails('position', user);user.position_EDIT=false"
                    class="position editBox form-control validate rptInfo "    type="text" pInputText [(ngModel)]="user.position_TOEDIT" [ngModelOptions]="{standalone: true}" [(ngModel)]="user.position">
                      <option [ngValue]="'Cross'">
                        Cross
                      </option>
                      <option [ngValue]="'TopLeft'">
                        TopLeft
                      </option>
                      <option [ngValue]="'TopRight'">
                        TopRight
                      </option>
                      <option [ngValue]="'BottomLeft'">
                        BottomLeft
                      </option>
                      <option [ngValue]="'BottomRight'">
                        BottomRight
                      </option>
                    </select>
       
                  </span>
                  <br>
                  </div>-->
                  <br>
                  Date Created:  {{user.DATE_CREATED}}
                  <br>
                  Created By:  {{user.CREATED_BY}}
				  <br>
				  Set Default: <input type="checkbox" [checked]="user.COMPANY_DEFAULT=='Y'" (change)="setDefaultWM(user.WATERMARK_ID)">
                </div>
              </div>
            </div>
          </ng-template>
          <!-- <ng-template pTemplate="footer">Choose from the list.</ng-template> -->
        </p-dataView>
        </div>
        <div id="templates" style="color:white" class="tab-pane fade"><br>
          <p-table #ttt styleClass="p-datatable-sm" [value]="allTemplates" [columns]="templateCols" [scrollable]="true"
            scrollHeight="78vh">
            <ng-template pTemplate="caption">

              <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
                <span>
                  {{allTemplates.length}} Company Templates
                 
                  <!-- <a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background:#58a400; color:white"
                    data-toggle="modal" data-target="#reportsModal2" (click)="newSlot=true;"> Add New Repeat Field</a> -->
                    <i *ngIf="companyTemplatesLoading" class="pi pi-spin pi-spinner"
                    style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>

                    <a href="javascript:void(0)" class="btn btn-sm btn-outline-light pt-0 pb-0 pl-1 pr-1 ml-4"
                    title="Export to Excel" (click)="exportExcel1()"> 
          
                    <span> Export to Excel</span>
                  </a>
                </span>
                <span>
                <input type="text" pInputText placeholder="Search"
                  (input)="ttt.filterGlobal($event.target.value, 'contains')" style="background-color: rgb(28 36 51); padding: 3px; border: 0px; color: white"> 
                </span>
              </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>

              <tr style="font-size:12px">
                <th *ngFor="let col of columns; trackBy: trackByFuntion" [ngStyle]="{'width': col.width}" style="padding:1px; font-size:11px" [pSortableColumn]="col.field">
                  {{col.header}}
                  <p-sortIcon [field]="col.field"></p-sortIcon>

              </tr>
              <tr> 
                <th *ngFor="let col of columns; let i=index; trackBy: trackByFuntion" style="padding:2px">
                 <input *ngIf="col.field!='CATEGORY_NAME' && col.field!='SUBCATEGORY_NAME'&& col.field!='STATUS'" class="inputHeader" pInputText type="text"
                    (input)="ttt.filter($event.target.value, col.field, 'contains')"
                    style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px">
                    <select class="inputHeader ml-1"  style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px"  *ngIf="col.field=='SUBCATEGORY_NAME'"[(ngModel)]="selectedFilter"  (change)="filterTemplates(selectedFilter)">
                      <option [ngValue]="{'SUBCATEGORY_NAME': ''}">
    
                      </option>
                      <option *ngFor="let templatefilter of templateFilterOptions; trackBy: trackByFuntion" [ngValue]="templatefilter">
    
                        {{templatefilter.CATEGORY? templatefilter.CATEGORY: templatefilter.SUBCATEGORY_NAME}}
                      </option>
                    </select>
                    <select class="inputHeader ml-1"  style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px" *ngIf="col.field=='CATEGORY_NAME'" [(ngModel)]="selectedFilter2" (change)="filterTemplates2(selectedFilter2)">
                      <option [ngValue]="{'CATEGORY': ''}">
    
                      </option>
                      <option *ngFor="let templatefilter of templateFilterOptions2; trackBy: trackByFuntion" [ngValue]="templatefilter">
    
                        {{templatefilter.CATEGORY? templatefilter.CATEGORY: templatefilter.SUBCATEGORY_NAME}}
                      </option>
                   
                    </select>

					<select class="inputHeader ml-1"  style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px" *ngIf="col.field=='STATUS'" [(ngModel)]="selectedFilter3" (change)="filterTemplates3(selectedFilter3)">
						<option [ngValue]="''">
	  
						</option>
						<option [ngValue]="'Active'">
	  
						  Active
						</option>
						<option [ngValue]="'Inactive'">
	  
							Inactive
						  </option>
					  </select>
                  <!-- <input *ngIf="i==0" pInputText type="text"
                              (input)="tt.filter($event.target.value, 'flat', 'projectnumname')"
                              style="margin:0 2px; font-size:12px; width:98%;"> -->
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user let-i="rowIndex" let-columns="columns">
              <tr style="font-size:12px">
                <td *ngFor="let col of columns; trackBy: trackByFuntion" [ngStyle]="{'width': col.width}" style="padding:4px; border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)">
                  <span class="line-clamp1" *ngIf="col.field!='SUBCATEGORY_NAME' && col.field!='TEMPLATE_TITLE' && col.field!='STATUS'&&col.field!='DATE_UPDATED'" style="float:left">{{user[col.field]}} </span>
                  <span *ngIf="col.field=='STATUS'">
                    {{user.STATUS}}
                    <a title="Change status" style="cursor:pointer; float:right" *ngIf="user.STATUS=='Active'"
                      (click)=changeTemplateStatus(user)>
                      <i class="erisIconColor fas fa-toggle-on"></i>
                    </a>
                    <a title="Change status" style="cursor:pointer; float:right" *ngIf="user.STATUS!='Active'"
                      (click)=changeTemplateStatus(user)>
                      <i class="erisIconColor fas fa-toggle-off"></i>
                    </a>
                  </span>
                  <span class="line-clamp1" *ngIf="col.field=='TEMPLATE_TITLE'">
                          <div style="position:relative;">
                            <div style="max-width:calc(100% - 40px);" class="line-clamp">
                            <a style="color:rgb(195,212,47); cursor: pointer; margin-right:19px; text-overflow: ellipsis; "
                            [href]="'template/'+user.TEMPLATE_ID" target=_blank
														title="Edit">{{user.TEMPLATE_TITLE}}</a><span>({{user.TEMPLATE_VERSION_NO}})</span>
                            </div>
                            <div style="position:absolute;right:0;top:-5px; cursor: pointer;">
                            <a *ngIf="companyGroupIndicator" class="ml-1 groupIcon" [ngClass]="{'disabled':!user.GROUP_LIST}" style="cursor:pointer; float:right; margin:3px;" (click)="op123.toggle($event);" title="List of Groups"><i class="erisIconColor fab fa-google"></i></a>
                            <a class="ml-1"    style="cursor:pointer; float:right; margin:3px;" (click)="getAllTempByTypeID(user.TEMPLATE_ID); op1.toggle($event); setExcelTitle(user.TEMPLATE_TITLE)"
                            title="List of Reports"><i class="erisIconColor fas fa-registered"></i></a>
                            <a class="ml-1"    style="cursor:pointer; float:right; margin:3px;" 
                                (click)="resetTypeList(); updatetemplatetitle_op.toggle($event);updateTemplateTitlePermission=false;checkUpdateTemplateTitlePermission(user.TEMPLATE_ID);"
                            title="Edit Template title"><i class="erisIconColor fas fa-pen"></i></a>
                            </div>
                          </div>  
                            <p-overlayPanel #updatetemplatetitle_op [appendTo]="'body'">
                              <ng-template pTemplate> 
                                <!--              -->
                                <input [(ngModel)]="user[col.field]" class="rptInfo" style="width:300px" type="text"  maxlength="110">
											          	<button (click)="updateTemplateTitle(user); updatetemplatetitle_op.hide()" [disabled]="!updateTemplateTitlePermission"
												            class="btn m-0 uploadBtn">Submit</button>
                                </ng-template>
                                </p-overlayPanel>
                                <p-overlayPanel #op123 [appendTo]="'body'" [dismissable]="true" [showCloseIcon]="true">
                                  <ng-template pTemplate> 
                                    <label class="popheader" style="color:#C2D63F">Group List:</label>
                                    <ng-container *ngFor="let group of user.GROUP_LIST.split(',')">
                                      <hr class="line1"><label style="font-size: 12px;">{{group}}</label>
                                    </ng-container>
                                  </ng-template>
                              </p-overlayPanel>
                            <p-overlayPanel #op1 [appendTo]="'body'"  [style]="{'max-width':'70vw'}">
                              <ng-template pTemplate>
                                <span  style="font-size:.8em; color: #C2D63F;" *ngIf="typeList.length==0">
                                  No Reports Were Found
                                </span>
                                <ng-container >
                              <!--flagflag-->
                                    <p-table *ngIf="typeList.length!=0" #dt [value]="typeList" >
                                      <ng-template pTemplate="caption">
                                        <i class="pi pi-search"></i>
                                        <input type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Global Search" style="font-size:11px; padding:2px"/>
                                        <a href="javascript:void(0)" class="btn btn-sm btn-outline-light pt-0 pb-0 pl-1 pr-1 ml-4"
                                            title="Export to Excel" (click)="exportExcel2()"> 
                              
                                            <span> Export to Excel</span>
                                        </a>
                                      </ng-template>
                                          <ng-template pTemplate="header" >
                                                          <tr>
                                                            <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field" >Report Title
                                                              <p-sortIcon field="code"></p-sortIcon>   
                                                            </th>
                                                            <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Project Number
        
                                                              <p-sortIcon field="code"></p-sortIcon>   
                                                            </th>
                                                            <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Property Name
                                                              <p-sortIcon field="code"></p-sortIcon>   
                                                            </th>
                                                            <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Property Address
                                                              <p-sortIcon field="code"></p-sortIcon>   
                                                            </th>
                                                            <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Property City
                                                              <p-sortIcon field="code"></p-sortIcon>   
                                                            </th>
                                                            <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Property State <br> Province
                                                              <p-sortIcon field="code"></p-sortIcon>   
                                                            </th>
                                                            <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Property Zip <br> Postal Code
                                                              <p-sortIcon field="code"></p-sortIcon>   
                                                            </th>
                                                            <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Transaction Type
                                                              <p-sortIcon field="code"></p-sortIcon>   
                                                            </th>
                                                            <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Protocol
                                                              <p-sortIcon field="code"></p-sortIcon>   
                                                            </th>
                                                            <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Status
                                                              <p-sortIcon field="code"></p-sortIcon>  
                                                            </th>
                                                    
                                                            <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Last Edited
                                                              <p-sortIcon field="code"></p-sortIcon>   
                                                            </th>
                                                            <th *ngIf="companyGroupIndicator" style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Report Group
                                                              <p-sortIcon field="code"></p-sortIcon>   
                                                            </th>
                                                          </tr>
                                                      </ng-template>
                                                      <ng-template pTemplate="body" let-rowData >
                                                          <tr>
                                                            <td style="padding:1px; font-size:11px" ><a  target="_blank" 
                                                              [attr.href]="'/report/' + rowData.PROJECT_ID +'/' + rowData.REPORT_ID"
                                                                style="font-size:.8em; color: #C2D63F;"
                                                                >{{rowData.REPORT_TITLE}}</a>
                                                              </td>
                                                              <td style="padding:1px; font-size:11px">{{rowData.PROJECT_NUMBER}}</td>
                                                              <td style="padding:1px; font-size:11px">{{rowData.PROPERTY_NAME}}</td>
                                                              <td style="padding:1px; font-size:11px">{{rowData.ADDRESS_LINE1}}</td>
                                                              <td style="padding:1px; font-size:11px">{{rowData.CITY}}</td>
                                                              <td style="padding:1px; font-size:11px">{{rowData.PROVSTATE}}</td>
                                                              <td style="padding:1px; font-size:11px">{{rowData.POSTALZIP}}</td>
                                                              <td style="padding:1px; font-size:11px">{{rowData.TRANSACTION_TYPE}}</td>
                                                              <td style="padding:1px; font-size:11px">{{rowData.PROTOCOL}}</td>
                                                              <td style="padding:1px; font-size:11px">{{rowData.STATUS}}</td>
                                                              <td style="padding:1px; font-size:11px">{{rowData.LAST_UPDATED}}</td>
                                                              <td *ngIf="companyGroupIndicator" style="padding:1px; font-size:11px">{{rowData.REPORT_GROUP.GROUP_NAME}}</td>
                                                          </tr>
                                                      </ng-template>
                                                  </p-table>			
                                </ng-container>
                              </ng-template>
                            </p-overlayPanel>
                  </span>
                  <span class="line-clamp1" *ngIf="col.field=='SUBCATEGORY_NAME'" style="float:left"> 
                    <span *ngIf="user.CATEGORY_NAME">
                   {{user[col.field]}} ({{templateCountDict[user[col.field]]? templateCountDict[user[col.field]]:0  }})
                    </span>
                  </span>
                  <span *ngIf="col.field=='EDIT'">
                    <a style="cursor:pointer" class="ml-1" data-target='#copyWith' data-toggle="modal" (click)="templateRow=user;">
                    <i class="fas fa-copy erisIconColor"></i></a>
                    
                  </span>
                  <span *ngIf="col.field=='DATE_UPDATED'">
										<a (click)="getTemplateHistory(user); op1.toggle($event)"  style="cursor:pointer; color:rgb(195,212,47)"> {{user[col.field]}}</a>
										<p-overlayPanel #op1 [appendTo]="'body'" 		[style]="{'z-index':'9999999999999999', 'min-width':'300px'}">

											<ng-template pTemplate>
												<!-- <span *ngFor="let history of rowData.RW_REPORT_HISTORY">
													<a class="erisGreen" [title]="history.CHANGE_REASON_DESC"> {{history.DATE_UPDATED}} -- {{history.UPDATED_BY}}</a>
													<br>
												</span> -->
												<table  style="padding:1px; font-size:11px" [pSortableColumn]="col.field" style="width:90%; border: 1px solid black;  border-collapse: collapse;">
													<thead>
													  <tr style="color:rgb(195,212,47); font-size:12px">
									
													  <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Edited By</th>
													  <th style="padding:1px; font-size:11px" [pSortableColumn]="col.field">Edit Date</th>
													  </tr>
													</thead>
													<tbody>
													  <ng-container *ngFor="let history of user.RW_TEMPLATE_HISTORY; let i=index; trackBy: trackByFuntion">
														<tr style="color:rgb(195,212,47); font-size:12px">
														<td style="padding:1px; font-size:11px" [pSortableColumn]="col.field">{{history.UPDATED_BY}}</td>
														<td style="padding:1px; font-size:11px" [pSortableColumn]="col.field">{{history.DATE_UPDATED}}</td>
														
														</tr>
													  </ng-container>
													</tbody>
													</table>
											</ng-template>
										</p-overlayPanel>
									</span>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>


      </div>
    </div>
    <div id="import" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="false">

      <div class="modal-dialog modal-dialog-centered" [style.max-width]="excelJson? '80%':'50%'">
        <div class="modal-content" style="background-color:#cDcDcD">
        
          <div class="modal-header">
            <h6 *ngIf="sheets.length==0" class="modal-title">Import Excel</h6>
            <nav class="navbar navbar-expand-lg navbar-light p-0">
              
              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mr-auto">
                <li class="nav-item" [class.active]="sheet==selectedSheet"  *ngFor="let sheet of sheets; trackBy: trackByFuntion">
                  <a (click)="resetSheet(); selectedSheet=sheet; selectSheet()" class="nav-link" > <h6>{{sheet}}</h6> </a>
                </li>
                </ul>
              </div>
            </nav>
            
            <button 
              class="btn btn-dark btn-sm pt-0 pb-0 pl-2 pr-2 ml-3"
              type="button"
              id="batchButton"
              href="javascript:void(0)"
              title="Help"
              #batchButton
            (click)='testFunction()'>How to Upload a Library</button>

            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
  
        
          <div class="modal-body">
  
            <p-table [value]="excelJson" [columns]="excelCols">
              <ng-template pTemplate="header" let-columns>
                <tr style="font-size:12px">
                  <th style="padding: 1px; padding-left: 3px;" *ngFor="let col of columns; trackBy: trackByFuntion" >
                    
                    <select style="color:white; background:#323232;  max-width:100%" [(ngModel)]="col.changeHeader"
                    (change)="changeCol();">
                    <option *ngFor="let pre of costUpload? presetCostCols: presetCols; trackBy: trackByFuntion" [value]='pre'>
                      {{pre}}
                    </option>
                  </select>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body"  let-rowData let-columns="columns">
  
              
                <tr style="font-size:12px;">
                  <td style="padding: 1px; padding-left: 3px;" *ngFor="let col of columns; trackBy: trackByFuntion" >
                    <span>
                      {{rowData[col.header]}}
                    </span>
      
                  </td>
                </tr>
              </ng-template>
            </p-table>
            <div class="input-group col-md-12 justify-content-center text-center mt-1"  >
              <input id="uploadState" [style.max-width]="excelJson? '50%':'80%'" #excelFile class="col-md-9 rptInfo mr-1"
                type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                [(ngModel)]="sheet1"/>
              
              <div class="input-group-append">
                <button title="Upload File"
                  class="btn btn-dark btn-sm pt-0 pb-0 pl-2 pr-2"
                  type="button"
                
                  (click)='uploadExcel()'><i
                    class="fas fa-file-upload"></i></button>
                
              
              </div>
              <span id="spinner" class="fa fa-spinner fa-spin"
                style="font-size:20px; display:none"></span>
              <span id="inputWarn" class="fas fa-exclamation"
                style="margin-left:4px;font-size:16px; display:none; color:red"></span>
              <span id="inputSuccess" class="fas fa-check"
                style="margin-left:4px;font-size:16px; display:none; color:green"></span>
            </div>
            <div class="col-md-12 justify-content-center text-center mt-1">
  
              <button *ngIf="excelJson"
                class="btn btn-dark btn-sm pt-0 pb-0 pl-2 pr-2"
                type="button"
                [disabled]="!manageLibraryPermission"
                (click)='uploadBatchProjects()'>Upload Libraries</button>
            </div>
            </div>
  
          </div>
          </div>
          
           
  
    </div>
    <div id="uploadHF" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="false">

      <div class="modal-dialog modal-dialog-centered" [style.max-width]="'20%'">
        <div class="modal-content" style="background-color:#cDcDcD">
        
          <div class="modal-header">
            <h6 class="modal-title">Upload File</h6>

            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
  
    
          <div class="modal-body">
            <label data-error="wrong" data-success="right" for="defaultForm-pass">Title:</label>
            <input maxlength="100" [ngModelOptions]="{standalone: true}" [(ngModel)]="hfTitle" id="defaultForm-pass"
              class="form-control validate rptInfo">
            <br>
      
            <div class="input-group col-md-12 justify-content-center text-center mt-1"  >
              <input #hfFile class="col-md-9 rptInfo mr-1"
                type="file" accept=".html"
                />
              
              <div class="input-group-append">
                <button title="Upload File"
                  class="btn btn-dark btn-sm pt-0 pb-0 pl-2 pr-2"
                  type="button"
                
                  (click)='uploadHF()'><i
                    class="fas fa-file-upload"></i></button>
                
              
              </div>
              <span id="spinner" class="fa fa-spinner fa-spin"
                style="font-size:20px; display:none"></span>
              <span id="inputWarn" class="fas fa-exclamation"
                style="margin-left:4px;font-size:16px; display:none; color:red"></span>
              <span id="inputSuccess" class="fas fa-check"
                style="margin-left:4px;font-size:16px; display:none; color:green"></span>
            </div>
            <div class="modal-footer d-flex justify-content-center">
              <button  (click)="insertHF() " class="btn btn-default btn-outline-dark">Add {{uploadtype}}</button>
            
            </div>

            </div>
  
          </div>
          </div>
          
           
  <!--this is the edit tab-->
    </div>
    <div  class="modal fade" id="reportsModal" #reportsModal tabindex="-1" role="dialog"  data-keyboard="false" data-backdrop='false' aria-labelledby="myModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document" [ngStyle]="{'max-width':slotShow?'1300px':'1000px'}">
        <div class="modal-content" style="background:#4C4C4C;">
          <div class="modal-header" style="color:white">
            <h6 *ngIf="newLibrary" class="modal-title w-100 font-weight-bold">Add New Library</h6>
            <h6 *ngIf="!newLibrary" class="modal-title w-100 font-weight-bold">Edit Library</h6>
            <button (click)="newLibrary=true; formCheck=false;clearLibraryForm(); this.newLibPara0 = ' ';this.newLibPara2 = ' '" type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body mx-3">
		  <div class="row" [ngStyle]="{'max-width':slotShow?'1200px':'900px'}" style="margin: 10px; padding-right:0; color:white;max-height:700px;">
			<div *ngIf="slotShow" style="width:25%; height:400px; overflow:auto">
			
					<label>Repeat Field</label>
					<button type="button" class="btn btn-outline-light btn-sm float-md-right" (click)="slotShow=false;">Close</button>
					<p-table #dt2 [value]="slotsForLib" [paginator]="false" [globalFilterFields]="['KEY','CONTENT']"  (onFilter)="onFilter($event, dt2)"
					[scrollable]='true' scrollHeight="300px">
						<ng-template pTemplate="caption">
							
									<i class="pi pi-search" style="margin:4px 4px 0 0"></i>
									<input type="text" pInputText size="20" placeholder="Filter"
										(input)="dt2.filterGlobal($event.target.value, 'contains')"			
										style="width:auto;">					
					</ng-template>
						<ng-template pTemplate="body" let-rowData>
							<tr *ngIf="rowData.KEY&&rowData.STATUS=='Active'">
								<td>
									<div class="card" > 						
										<div class="row"  style="width:100%">
											<p style="width:80%; margin-left:16px;color:rgb(195,212,47);">{{rowData.KEY}}<!--<span style="color:#04B486; margin:0 2px">({{rowData.TYPE}})</span>-->
											<a *ngIf="rowData.TYPE!='PDF'" href="javascript:void(0)" [ngStyle]="{'color':rowData.CONTENT.length==0?'gray':'none'}"style="width:5%; margin-top:2px; float:right;" title="Content" (click)="op11.toggle($event);" ><i class="fas fa-eye"></i>
											<p-overlayPanel #op11 [appendTo]="reportsModal" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="2000" [style]="{'width': '400px'}" (onShow)="getTable(rowData)">
                                                <ng-template pTemplate>
                                                    <div style="margin: 6px; color:#C2D63F;max-height:500px; overflow:auto; font-size:.9em"> 
													<strong>{{rowData.KEY}}</strong>
													<strong>Category : </strong> 
													<span style="color:white">{{rowData.CATEGORY}}</span><br>
													<strong>Type : </strong> 
													<span style="color:white">{{rowData.TYPE}}</span><br>
														<strong *ngIf="(rowData.TYPE!='Table')&&(rowData.TYPE!='Selection')">Content :</strong>
														<div *ngIf="(rowData.TYPE!='Table')&&(rowData.TYPE!='Selection')&&(rowData.TYPE!='File')">
															<textarea  style="width:100%" rows="3"  [value]="rowData.CONTENT">
															</textarea>
															<!--<button type="button" class="btn btn-outline-light btn-sm float-md-right m-4" (click)="updateSlotContent($event,rowData.SLOT_ID);op11.hide();">Update</button>-->
			                                           </div>
													   <div *ngIf="rowData.TYPE=='Selection'">
															<strong>Options</strong><br>
															<ng-container *ngFor="let item of tableContent; trackBy: trackByFuntion">
																<span style="color:white">. {{item}}</span><br>
															</ng-container>
														</div>	
														<div *ngIf="rowData.TYPE=='Table'">
															<strong>Headers of Table</strong>
															<table style="color:white; width:90%; border: 1px solid black;  border-collapse: collapse;">
															<thead>
																<tr>
																<th>No.</th>
																<th>Name</th>
																<th>Type</th>
																</tr>
															</thead>
															<tbody>
																<ng-container *ngFor="let item of tableContent; let i=index; trackBy: trackByFuntion">
																	<tr>
																	<td>{{i}}</td>
																	<td>{{item.NAME}}</td>
																	<td>{{item.TYPE}}</td>
																	</tr>
																</ng-container>
															</tbody>
															</table>
														</div>
													</div>
                                                </ng-template>
                                            </p-overlayPanel>
											</a>
											<a href="javascript:void(0)" style="width:5%; margin-top:2px; float:right" (click)="addRepeat('slot', rowData)"><i class="fas fa-arrow-right"></i></a>	
											<br>
											<span *ngIf="rowData.SHORT_CONTENT.length>0" style="margin-left:6px; color:white">{{rowData.SHORT_CONTENT}}	</span>
											
										</div>								
									</div>			
								</td>
							</tr>            
						</ng-template>
	
					</p-table>
				
			</div>	 
              <div [ngStyle]="{'width':slotShow?'75%':'100%'}">
               <!-- <div Style="width:75%">-->
                <label class="col-md-2">Title: <span style="color:red">*</span></label> 
                <input class="col-md-9 ml-2" type="text" [(ngModel)]="title" id="titleID" />
                <br>
                <label class="col-md-2">Identifier: <i class="fas fa-info-circle iconBtn" (click)="op302.toggle($event)"></i></label>
                <input type="text" class="col-md-9  ml-2" id="libLabel" placeholder="separate your identifier by ;"/>
                <button (click)="getLibLabels(); op301.toggle($event);"><i class="fas fa-chevron-down" style="pointer-events:none; color:#C2D63F"></i></button>
                <p-overlayPanel #op301 [appendTo]="reportsModal" [dismissable]="false" [showCloseIcon]="true" [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '300px'}">
                  <ng-template pTemplate>
                    <div style="max-height:400px; padding:4px; width:300px; overflow:auto; white-space: nowrap;">
                      <ng-container *ngFor="let label of allLabels; trackBy: trackByFuntion">
                        <div class="listItem2" style="margin:0; width:260px; border:1px ridge black" >
							<a href="javascript:void(0)" style="color:rgb(195,212,47); font-size:.8em; margin:2px" (click)="addToIden(label.LABEL, 'libLabel')">{{label.LABEL}}</a><br>
						</div>
					  </ng-container>
                    </div>																
                  </ng-template>
                </p-overlayPanel>
				<p-overlayPanel #op302 [appendTo]="reportsModal" [dismissable]="false" [showCloseIcon]="true" [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '620px'}">
					<ng-template pTemplate>
						<div style="max-height:600px; padding:0; width:580px; overflow:auto;">
							<ul>
								<li class="instr">You may select multiple Identifiers from the dropdown list.</li>
								<li class="instr">If the Identifier required is not in the dropdown list, you may create a new one by typing it into the “Identifier” field (under the “Title” field).</li>
							</ul>
						</div>																
					</ng-template>
				</p-overlayPanel>
                <i class="fas fa-plus iconBtn" (click)="addLabel2($event)"></i>
                <div  class="col-md-2"></div>
                <div class="col-md-9 ml-2" >
                  <ng-container *ngFor="let label of inputLabels.split(';') let i=index; trackBy: trackByFuntion">
                    <label *ngIf="label.trim().length>0" class="tag">{{label}}<i class="fas fa-times iconBtn" (click)='removeLabel2(i)'></i></label>
                  </ng-container>
                </div>
                <!--Instruction and content here-->
                <label class="col-md-5">Instruction:</label>
                <div class="ml-3 mr-4 ckContainer" style="max-height:200px; overflow:auto">
                  <app-paragraph [srcViewer]="'N'" [editorType]="'lite'" [(content)]="newLibPara0" (outText)="libPara($event, 0)" (onExit)="libPara($event, 1)"></app-paragraph>
                </div>
                <label class="col-md-2">Content: </label>
                <div style="max-height:260px">
                  <div class="ml-3 mr-4 ckContainer"  style="max-height:240px; overflow:auto">
                    <app-paragraph [srcViewer]="'Y'" [editorType]="'lite'" [(content)]="newLibPara2" [addedSlot]="addedItem" [getText]="itemIndex" (outText)="libPara($event, 2)" (onExit)="libPara($event, 3)"></app-paragraph>
                  </div>
                  <button  class="btn btn-outline-light rf-btn ml-1" title="Add Repeat Field" (click)="addSlotPrep()">Repeat Fields</button>		
                </div>														
                <span *ngIf="addLibWarn" style="color:red">{{addLibWarnMessage}}</span>

                <button  *ngIf="newLibrary" (click)="saveNew(true); formCheck=true;" [disabled]="!manageLibraryPermission" class="btn btn-outline-light btn-sm float-md-right m-4">Create</button>
                <button  *ngIf="newLibrary" (click)="saveNew(false); formCheck=true;" [disabled]="!manageLibraryPermission" class="btn btn-outline-light btn-sm float-md-right m-4">Save and Create New</button>
                <button  *ngIf="newLibrary" (click)="newLibrary=true; formCheck=false;clearLibraryForm(); this.newLibPara0 = ' ';this.newLibPara2 = ' '" 
                        type="button" class="close" data-dismiss="modal" aria-label="Close" class="btn btn-outline-light btn-sm float-md-right m-4">Cancel</button>

                <button  *ngIf="!newLibrary" (click)="saveUpdate(); formCheck=true" [disabled]="!manageLibraryPermission" class="btn btn-outline-light btn-sm float-md-right m-4">Save</button>		                                           
                </div>
    
                </div>
            
          </div>
     

        </div>
      </div>
    </div>


    <div class="modal fade" id="watermarkForm" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content"  style="background:#4C4C4C;color:white">
          <div class="modal-header text-center">
            <h4  *ngIf="!watermarkEdit" class="modal-title w-100 font-weight-bold">Add New Watermark</h4>
            <h4 *ngIf="watermarkEdit" class="modal-title w-100 font-weight-bold">Edit Watermark</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body mx-3">
            <form>

              <div class="md-form mb-3">
                <label data-error="wrong" data-success="right" for="defaultForm-pass">Title:</label><span [ngStyle]="{'color':watermarkTitle?.trim().length>0?'white':'red'}">*</span>
                <input maxlength="100" [ngModelOptions]="{standalone: true}" [(ngModel)]="watermarkTitle" id="defaultForm-pass"
                  class="form-control validate rptInfo">
                  <!-- <label data-error="wrong" data-success="right" for="defaultForm-pass">PDF:</label>
                  <input [ngModelOptions]="{standalone: true}" [(ngModel)]="watermarkData.pdf_url" id="defaultForm-pass"
                    class="form-control validate rptInfo"> -->
                    <label data-error="wrong" data-success="right" for="defaultForm-pass">Font-size:</label><span [ngStyle]="{'color':watermarkData.fontsize.length>0?'white':'red'}">*</span>
                    <input type="number" [ngModelOptions]="{standalone: true}" min="6" [(ngModel)]="watermarkData.fontsize" id="defaultForm-pass"
                      class="form-control validate rptInfo">
                      <label data-error="wrong" data-success="right" for="defaultForm-pass">Font Name:</label><span [ngStyle]="{'color':watermarkData.fontname.length>0?'white':'red'}">*</span>
  
                      <select      class="form-control validate rptInfo " [ngModelOptions]="{standalone: true}" [(ngModel)]="watermarkData.fontname">
                        <!--<option [ngValue]="'Courier-Bold'">
                          Courier-Bold
                        </option>
                        <option [ngValue]="'Courier-Oblique'">
                          Courier-Oblique
                        </option>-->
                        <!--<option [ngValue]="'Courier-BoldOblique'">
                          Courier-BoldOblique
                        </option>-->
                        <option [ngValue]="'Helvetica'">
                          Helvetica
                        </option>
                        <option [ngValue]="'Helvetica-Oblique'">
                          Helvetica-Oblique
                        </option>
                      </select>
                  <label data-error="wrong" data-success="right" for="defaultForm-pass">Text:</label><span [ngStyle]="{'color':watermarkData.text?.trim().length>0?'white':'red'}">*</span>
                  <input [ngModelOptions]="{standalone: true}" [(ngModel)]="watermarkData.text" id="defaultForm-pass"
                    class="form-control validate rptInfo">
                    <label data-error="wrong" data-success="right" for="defaultForm-pass">Position:</label><span [ngStyle]="{'color':watermarkData.position.length>0?'white':'red'}">*</span>
  
                      <select      class="form-control validate rptInfo " [ngModelOptions]="{standalone: true}" [(ngModel)]="watermarkData.position">
                        <option [ngValue]="'Cross'">
                          Cross
                        </option>
                        <option [ngValue]="'TopLeft'">
                          TopLeft
                        </option>
                        <option [ngValue]="'TopRight'">
                          TopRight
                        </option>
                        <option [ngValue]="'BottomLeft'">
                          BottomLeft
                        </option>
                        <option [ngValue]="'BottomRight'">
                          BottomRight
                        </option>
                      </select>
                      <label data-error="wrong" data-success="right" for="defaultForm-pass">RGBA:</label><span [ngStyle]="{'color':watermarkData.color.trim().length>0?'white':'red'}">*</span>
                      <input (change)="rgba2hex(watermarkData.color)" class="form-control validate rptInfo " [cpOutputFormat]="'rgba'" [(colorPicker)]="watermarkData.color" [ngModelOptions]="{standalone: true}" [(ngModel)]="watermarkData.color"/>
              </div>
              <div class="md-form mb-3">
                Current Text:

                <span [style.color]="watermarkData.color" [style.font-size]="watermarkData.fontsize +'px'" [style.font-family]="watermarkData.fontname"> {{watermarkData.text}} </span>
                </div>
              <!-- <div class="md-form mb-3">

              </div> -->
     

            </form>
			<span *ngIf="watermarkWarn" style="color:red">All input required!</span>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button  *ngIf="!watermarkEdit" (click)="addWatermark() " class="btn btn-default btn-outline-light" [disabled]="!addWatermarkPermission">
              Add New Watermark</button>
            <button *ngIf="watermarkEdit"  (click)="editWatermark() " class="btn btn-default btn-outline-light" [disabled]="!editWatermarkPermission">
              Save</button>

          </div>

        </div>
      </div>
    </div>

    <div class="modal fade" id="costLibraryModal" #costLibraryModal tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content" style="background:#4C4C4C; color:white">
        <div class="modal-header text-center">
          <h4 *ngIf="newCostLibrary" class="modal-title w-100 font-weight-bold">Add New Cost Library</h4>
          <h4 *ngIf="!newCostLibrary" class="modal-title w-100 font-weight-bold">Edit Cost Library</h4>
          <button (click)="resetCostLibrary()" type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body mx-3">
          <form>

            <div class="md-form mb-3">
              <label data-error="wrong" data-success="right" for="defaultForm-pass">
                Title:</label> <span style="color:red">*</span>
                <form [formGroup]="form1">
                  <input id="new cost library" [(ngModel)]="costLibraryForm.ITEM_TITLE" id="defaultForm-pass"
                  class="form-control validate rptInfo" formControlName="confirmCostTitle">
                 
                </form>
                <span *ngIf="addCostWarn">
                  <span style="color: red"> {{addCostWarnMessage}} </span>
                </span>
                <!--span *ngIf = "formCheck">
                  <span style='margin-bottom:5px' style="color:red">
                  Please enter a title
                </span>
                </span-->
                  <!-- 
                    <label data-error="wrong" data-success="right" for="defaultForm-pass">Title:</label>
                    <input [ngModelOptions]="{standalone: true}" [(ngModel)]="costLibraryForm.COST" id="defaultForm-pass"
                      class="form-control validate rptInfo">
                      <label data-error="wrong" data-success="right" for="defaultForm-pass">Title:</label>
                    <input [ngModelOptions]="{standalone: true}" [(ngModel)]="costLibraryForm.UNIT" id="defaultForm-pass"
                      class="form-control validate rptInfo"> -->
            </div>
            <div class="md-form mb-3">

              <div class="row">

                <div class="col-md-4">
                  <label data-error="wrong" data-success="right" for="defaultForm-pass">EUL:</label>
                  <input [ngModelOptions]="{standalone: true}" [(ngModel)]="costLibraryForm.EUL" id="defaultForm-pass"
                    class="form-control validate rptInfo">
                </div>
                <div class="col-md-4">
                  <label data-error="wrong" data-success="right" for="defaultForm-pass">Cost:</label>
                  <input [ngModelOptions]="{standalone: true}" [(ngModel)]="costLibraryForm.COST" id="defaultForm-pass"
                    class="form-control validate rptInfo">
                </div>
                <div class="col-md-4">
                  <label data-error="wrong" data-success="right" for="defaultForm-pass">Unit:</label>
                    <select style="width:100%" class="form-control validate rptInfo" [(ngModel)]="costLibraryForm.UNIT"
                    [ngModelOptions]="{standalone: true}" id="defaultForm-pass" placeholder="costLibraryForm.UNIT">
                      <option [value]="type.COST_UNIT_NAME" *ngFor="let type of units; trackBy: trackByFuntion">
                        {{type.COST_UNIT_NAME}} </option>
                      <option>
                        Test Option
                      </option>
                    </select>
                </div>
              </div>
            </div>
            <div class="md-form">
              <label data-error="wrong" data-success="right" for="defaultForm-pass">Identifier:</label>
                <input id="pcaLabel" [ngModelOptions]="{standalone: true}" [(ngModel)]="PCAIdFiller.Test" type="text" style="width:85%;" placeholder="separate your identifier by ;"/>
				<button (click)="op303.toggle($event);"><i class="fas fa-chevron-down" style="pointer-events:none; color:#C2D63F"></i></button>
					<p-overlayPanel #op303 [appendTo]="costLibraryModal" [dismissable]="false" [showCloseIcon]="true" [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '200px'}">
						<ng-template pTemplate>
							<div style="max-height:400px; padding:4px; width:200px; overflow:auto">
								<ng-container *ngFor="let label of allCostLabel; trackBy: trackByFuntion">
									<a href="javascript:void(0)" style="color:rgb(195,212,47); font-size:.8em; margin:2px" (click)="addToIden(label.IDENTIFIER, 'pcaLabel')">{{label.IDENTIFIER}}</a><br>
								</ng-container>
							</div>																
						</ng-template>
					</p-overlayPanel>
					<i style="float:right" class="erisGreen1 fas fa-plus iconBtn mt-2" (click)="addLabelPCA2()"></i>
                <div>
                  <ng-container *ngFor="let label of costLibraryForm.IDENTIFIERS.split(';') let i=index; trackBy: trackByFuntion">
                    <label *ngIf="label.trim().length>0" class="tag">{{label}}<i class="fas fa-times iconBtn" (click)='removeLabelPCA2(i)'></i></label>
                  </ng-container>
                </div>
            </div>

          </form>
        </div>
        <div class="modal-footer d-flex justify-content-center">
          <button  *ngIf="newCostLibrary" (click)="addCostLibrary(); formCheck=true "
            class="btn btn-default btn-outline-light" [disabled]="!manageLibraryPermission">Add Cost Library</button>
          <button  *ngIf="!newCostLibrary" (click)="updateCostLibrary(); formCheck=true  "
            class="btn btn-default btn-outline-light" [disabled]="!manageLibraryPermission">Save</button>
        </div>

      </div>
    </div>
  </div>
     
    <div id="libraryModal" #libraryModal class="modal fade" data-backdrop='false' style="z-index: 99999">
      <div class="modal-dialog modal-lg modal-dialog-centered " style="max-width:80%">
      <div class="modal-content" style="background:#444; color:#ccc">
        <!-- Modal Header -->
            <div class="modal-header">
              <h6 id="" class="modal-title">Library</h6>
           <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>        
            <!-- Modal body -->
            <div class="modal-body">				
          <div class="row p-2" >
          <div style="height:900px; overflow:auto;width:45%; padding-left:10px">
          <p-table #dt3 [value]="libraryData" [paginator]="false" [globalFilterFields]="['ITEM_TITLE','LABELS']" (onFilter)="onFilter($event, dt3)">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th>
                  <i class="pi pi-search" style="margin:4px 4px 0 0"></i>
                  <input type="text" pInputText size="20" placeholder="Filter" (input)="dt3.filterGlobal($event.target.value, 'contains')" style="width:auto">
                  <p-dropdown [options]="libLabels"  placeholder="Filter by Identifier" [style]="{'width':'40%','minWidth':'50px', 'margin-left':'20px'}" (onChange)="dt3.filter($event.value, 'LABELS', 'contains')"  [showClear]="true"></p-dropdown>
                </th>					
              </tr>		
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
              <tr *ngIf="rowData.STATUS=='Active'">
                <td>
                  <div class="card"  [ngClass]="{'active':curLibId.indexOf(rowData.LIBRARY_ID)>-1}" (click)="selLib(rowData)"> 						
                    <div class="row"><p style="width:85%; margin-left:16px">{{rowData.ITEM_TITLE}}</p>
                      <!--<a href="javascript:void(0)" style="width:5%; float:right" title="Preview" (click)="op3.toggle($event);" ><i class="pi pi-info-circle"></i></a>-->
                      <a href="javascript:void(0)" style="width:5%; float:right" title="Preview" (click)="op4.toggle($event);" ><i class="pi pi-eye"></i></a>					
                    </div>
                    <div class="row">
                    <ng-container *ngFor="let label of rowData.LABELS.split(';'); trackBy: trackByFuntion">
                      <label class="tag">{{label}}</label>
                    </ng-container>
                    </div>
                    <!--<p-overlayPanel #op3 [appendTo]="libraryModal" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '800px'}">
                                        <ng-template pTemplate>
                                            <div style="margin: 10px; color:#C2D63F;max-height:400px; overflow:auto"> 
                          <h6>{{rowData.ITEM_TITLE}}</h6>
                          <hr>
                          <div>
                            Instruction : {{rowData.INSTRUCTIONS}}
                          </div>										
                                            </div>
                                        </ng-template>
                                    </p-overlayPanel>-->
                    <p-overlayPanel #op4 [appendTo]="libraryModal" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '800px'}">
                                        <ng-template pTemplate>
                                            <div style="margin: 10px; color:#C2D63F;max-height:400px; overflow:auto"> 
                          <h6>{{rowData.ITEM_TITLE}}</h6>
                          
                          <hr>
                          <div>
                            <strong>Instruction :</strong> {{rowData.INSTRUCTIONS}}
                          </div>
                          <hr>
                          <div>
                            <strong>Content :</strong> {{rowData.CONTENT}}
                          </div>
                                            </div>
                                        </ng-template>
                                    </p-overlayPanel>
                  </div>			
                </td>
              </tr>            
            </ng-template>
      
          </p-table>	
        </div>
        <div class="d-flex flex-column justify-content-center p-3" style="width:9%" >
              <button type="button" class="btn btn-outline-light btn-sm" title="Add" (click)="addSelLib()">></button>
              <div style="height:40px"></div>
              <button type="button" [disabled]="(libraryData&&libraryData.length>10&&!filteredData)||(filteredData&&filteredData.length>10)" class="btn btn-outline-light btn-sm" title="Add All when total=<10" (click)="addAllSelLib()">>></button>
              <div style="height:40px"></div>
              <button type="button" class="btn btn-outline-light btn-sm" title="Remove" (click)="rmvAddedLib()"><</button>
              <div style="height:40px"></div>
              <button type="button" class="btn btn-outline-light btn-sm" title="Clear All" (click)="clearAddedLib()"><<</button>
              <div style="height:40px"></div>
              <button type="button" class="btn btn-outline-light btn-sm" title="Add Custom" (click)='cancleLib()'>Cancel</button>
              <div style="height:40px"></div>
              <button *ngIf="libToSlot" type="button" class="btn btn-outline-success btn-sm" title="Add to Repeat Field" (click)='addLibToSlot()'><i class="far fa-save"></i></button>
              <button *ngIf="!libToSlot" type="button" class="btn btn-outline-success btn-sm" title="Add to Page" (click)='addLibToDoc()'><i class="far fa-save"></i></button>
              <div style="height:40px"></div>
              <span class="fa fa-spinner fa-spin" style="font-size:36px; display:none"></span>
            
            </div>
        <div cdkDropList (cdkDropListDropped)="dropLib($event)" [cdkDropListData]="addedLib" class="rounded" style="height:600px; overflow:auto;width:45%; border:solid 1px rgb(195,212,47)">
          <ng-container *ngFor="let lib of addedLib; trackBy: trackByFuntion">
            <div cdkDrag class="card row m-3" style="width:95%" [ngClass]="{'active':curLibId.indexOf(lib.LIBRARY_ID)>-1}" (click)="selLib(lib)"> 						
              <p>{{lib.CONTENT}}</p>
            </div>
          </ng-container>
        </div>
        </div>
    
      </div>
      </div>
      </div>	
    </div>
        <div id="libraryModal" #libraryModal class="modal fade" data-backdrop='false' style="z-index: 99999">
      <div class="modal-dialog modal-lg modal-dialog-centered " style="max-width:80%">
      <div class="modal-content" style="background:#444; color:#ccc">
        <!-- Modal Header -->
            <div class="modal-header">
              <h6 id="" class="modal-title">Library</h6>
           <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>        
            <!-- Modal body -->
            <div class="modal-body">				
          <div class="row p-2" >
          <div style="height:600px; overflow:auto;width:45%; padding-left:10px">
         <!-- <label class="radio-inline">
           <input type="radio" name="libs" [checked]="rangeIndex==0" (change)="getLibRange(0)"> 
            Defined 
          </label> 
          <label class="radio-inline ml-3"> 
            <input type="radio" name="libs" [checked]="rangeIndex==1" (change)="getLibRange(1)">
            All
          </label>-->
          <p-table #dt3 [value]="libraryData" [paginator]="false" [globalFilterFields]="['ITEM_TITLE','LABELS']" (onFilter)="onFilter($event, dt3)">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th>
                  <i class="pi pi-search" style="margin:4px 4px 0 0"></i>
                  <input type="text" pInputText size="20" placeholder="Filter" (input)="dt3.filterGlobal($event.target.value, 'contains')" style="width:auto">
                  <p-dropdown [options]="libLabels"  placeholder="Filter by Identifier" [style]="{'width':'40%','minWidth':'50px', 'margin-left':'20px'}" (onChange)="dt3.filter($event.value, 'LABELS', 'contains')"  [showClear]="true"></p-dropdown>
                </th>					
              </tr>		
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
              <tr >
                <td>
                  <div class="card"  [ngClass]="{'active':curLibId.indexOf(rowData.LIBRARY_ID)>-1}" (click)="selLib(rowData)"> 						
                    <div class="row"><p style="width:85%; margin-left:16px">{{rowData.ITEM_TITLE}}</p>
                      <!--<a href="javascript:void(0)" style="width:5%; float:right" title="Preview" (click)="op3.toggle($event);" ><i class="pi pi-info-circle"></i></a>-->
                      <a href="javascript:void(0)" style="width:5%; float:right" title="Preview" (click)="op4.toggle($event);" ><i class="pi pi-eye"></i></a>					
                    </div>
                    <div class="row">
                    <ng-container *ngFor="let label of rowData.LABELS.split(';'); trackBy: trackByFuntion">
                      <label class="tag">{{label}}</label>
                    </ng-container>
                    </div>
                    <!--<p-overlayPanel #op3 [appendTo]="libraryModal" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '800px'}">
                                        <ng-template pTemplate>
                                            <div style="margin: 10px; color:#C2D63F;max-height:400px; overflow:auto"> 
                          <h6>{{rowData.ITEM_TITLE}}</h6>
                          <hr>
                          <div>
                            Instruction : {{rowData.INSTRUCTIONS}}
                          </div>										
                                            </div>
                                        </ng-template>
                                    </p-overlayPanel>-->
                    <p-overlayPanel #op4 [appendTo]="libraryModal" [dismissable]="true" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '800px'}">
                                        <ng-template pTemplate>
                                            <div style="margin: 10px; color:#C2D63F;max-height:400px; overflow:auto"> 
                          <h6>{{rowData.ITEM_TITLE}}</h6>
                          
                          <hr>
                          <div>
                            <strong>Instruction :</strong> {{rowData.INSTRUCTIONS}}
                          </div>
                          <hr>
                          <div>
                            <strong>Content :</strong> {{rowData.CONTENT}}
                          </div>
                                            </div>
                                        </ng-template>
                                    </p-overlayPanel>
                  </div>			
                </td>
              </tr>            
            </ng-template>
      
          </p-table>	
        </div>
        <div class="d-flex flex-column justify-content-center p-3" style="width:9%" >
              <button type="button" class="btn btn-outline-light btn-sm" title="Add" (click)="addSelLib()">></button>
              <div style="height:40px"></div>
              <button type="button" [disabled]="(libraryData.length>10&&!filteredData)||(filteredData&&filteredData.length>10)" class="btn btn-outline-light btn-sm" title="Add All when total=<10" (click)="addAllSelLib()">>></button>
              <div style="height:40px"></div>
              <button type="button" class="btn btn-outline-light btn-sm" title="Remove" (click)="rmvAddedLib()"><</button>
              <div style="height:40px"></div>
              <button type="button" class="btn btn-outline-light btn-sm" title="Clear All" (click)="clearAddedLib()"><<</button>
              <div style="height:40px"></div>
              <button type="button" class="btn btn-outline-light btn-sm" title="Add Custom" (click)='cancleLib()'>Cancel</button>
              <div style="height:40px"></div>
              <button *ngIf="libToSlot" type="button" class="btn btn-outline-success btn-sm" title="Add to Repeat Field" (click)='addLibToSlot()'><i class="far fa-save"></i></button>
              <button *ngIf="!libToSlot" type="button" class="btn btn-outline-success btn-sm" title="Add to Page" (click)='addLibToDoc()'><i class="far fa-save"></i></button>
              <div style="height:40px"></div>
              <span class="fa fa-spinner fa-spin" style="font-size:36px; display:none"></span>
            
            </div>
        <div cdkDropList (cdkDropListDropped)="dropLib($event)" [cdkDropListData]="addedLib" class="rounded" style="height:600px; overflow:auto;width:45%; border:solid 1px rgb(195,212,47)">
          <ng-container *ngFor="let lib of addedLib; trackBy: trackByFuntion">
            <div cdkDrag class="card row m-3" style="width:95%" [ngClass]="{'active':curLibId.indexOf(lib.LIBRARY_ID)>-1}" (click)="selLib(lib)"> 						
              <p>{{lib.CONTENT}}</p>
            </div>
          </ng-container>
        </div>
        </div>
    
      </div>
      </div>
      </div>	
    </div>

    <div cdkDrag class="modal fade" id="reportsModal2" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" data-backdrop="static"
      aria-hidden="true" >
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="background:#D8D8D8">
          <div class="modal-header text-center">
            <h6 *ngIf="newSlot">Add Repeat Field</h6>
            <h6 *ngIf="!newSlot">Update Repeat Field</h6>

            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>

          </div>
          <div class="modal-body mx-3">

            <div class="md-form mb-3" *ngIf="newSlot">
              <label class="col-md-3  ml-0 ">Title:<span style="font-weight:bold; color: red">*</span>
              </label>
              <input class="col-md-8 ml-0" type="text" [(ngModel)]='newSlotLabel' />
            </div>

            <div class="md-form mb-3" *ngIf="newSlot||newSlotType=='Selection'||newSlotType=='Narrative'">
              <label class="col-md-3  ml-0">Category:<span style="font-weight:bold; color: red">*</span>
              </label>
			  <input type='text' ngClass="col-md-7"[(ngModel)]='newSlotCat' style="padding-left:0">														
              <select class="col-md-1  ml-0" [(ngModel)]='newSlotCat' (mousedown)="getSlotPara()">
                <ng-container *ngFor="let cat of slotCategories; trackBy: trackByFuntion">
                  <option [value]="cat.CATEGORY">{{cat.CATEGORY}}</option>
                </ng-container>
              </select>
            </div>

            <div class="md-form mb-3" *ngIf="newSlot||newSlotType=='Selection'">
              
              <span *ngIf="newSlot">
              <label class="col-md-3  ml-0">Type: <span style="font-weight:bold; color: red">*</span></label>
              <select class="ml-1" [ngClass]="newSlotType=='Selection'? 'col-md-4':'col-md-8'" [(ngModel)]='newSlotType'>
                <ng-container *ngFor="let type of slotTypes; trackBy: trackByFuntion">
                  <option [value]="type.SLOT_TYPE">{{type.SLOT_TYPE}}</option>
                </ng-container>
              </select>
            </span>

            <span *ngIf="!newSlot">
              <label class="col-md-3  ml-0">Type: <span style="font-weight:bold; color: red">*</span></label>
            </span>

			  <select *ngIf="newSlotType=='Selection'" class="col-md-4" [(ngModel)]='newSlotMultiple' style="padding-left:0">
															<option value="N">Single Choice</option>
															<option value="Y">Multiple Choice</option>																
														</select>
            </div>
            <div class="container">
              <div class="md-form mb-3 row" style="max-height:300px">
                <label  *ngIf="newSlotType!='Selection'&&newSlotType!='Selection'&&newSlotType!='File'" class="col-md-3  ml-0">Content: </label>
                <textarea *ngIf="newSlotType!='Selection'&&newSlotType!='Selection'&&newSlotType!='File'" class="col-md-8  ml-0" rows="10"
                  [(ngModel)]='newSlotContent'></textarea>
                <!--<a *ngIf="newSlotType=='File'" [href]="newSlotFile.url" target=_blank>File</a>-->  
                <input *ngIf="newSlotType=='Selection'" class="col-md-7  mt-1" [(ngModel)]='newSlotOp'>
                <a href="javascript:void(0)" *ngIf="newSlotType=='Selection'" class="col-md-1 ml-0 mt-1 mr-0 slotBtn"
                  (click)="addOpItem($event)"><i class="erisGreen1 fas fa-plus"></i></a>
                  <a *ngIf="newSlotType!='Selection'&&newSlotType!='File'" href="javascript:void(0)" style="color:black" class="ml-0 btn btn-link btn-sm slotBtn" title="Create Repeat Field" data-target='#libraryModal' data-toggle="modal" (click)="libToSlot=true;filteredData=null">
                    <button class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4 " style="background-color: #C2D63F; color:white; font-weight:600; padding: 5px">
                    Libraries
                    </button>
                  </a>
					<ng-container *ngIf="newSlotType=='File'&&newSlot">
						<button  class="btn btn-outline-dark btn-op ml-0 mr-2" (click)="upload()">Upload File</button>
						<span *ngIf="uploading" class="fa fa-spinner fa-spin" style="font-size:16px; display:inline-block; color:black"></span>
						<br>
						<a [href]="newSlotFile.url"  style="width:100%; word-break: break-all;color:blue" target=_black>{{newSlotFile.name}}</a>															
																													
					</ng-container>
          <ng-container *ngIf="newSlotType=='File'&&!newSlot">
						<button  class="btn btn-outline-dark btn-op ml-0 mr-2" (click)="upload()">Change File</button>
						<span *ngIf="uploading" class="fa fa-spinner fa-spin" style="font-size:16px; display:inline-block; color:black"></span>
						<br>
						<a [href]="newSlotFile.url"  style="width:100%; word-break: break-all;color:blue" target=_black>{{newSlotFile.name}}</a>															
																													
					</ng-container>

                <!-- <a href="javascript:void(0)" class="ml-0 btn btn-link btn-sm slotBtn" title="Create Repeat Field"
                  data-target='#libraryModal' data-toggle="modal" (click)="libToSlot=true;filteredData=null">
                  LIB
                </a> -->
                <ng-container *ngIf="newSlotType=='Selection'&&newSlotOps.length>0">
                  <div class="col-md-3">
                                </div>
                                <div  class="selInput col-md-7" style="max-height:200px; overflow:auto">
                                  <ng-container *ngFor="let item of newSlotOps; trackBy: trackByFuntion">
                                    <span>. {{item}}</span><br>
                                  </ng-container>
                                </div>
                                <a href="javascript:void(0)" style="color:#666" (click)="clearOpItem()">Clear</a>
                              </ng-container>
              </div>
            </div>

            <button *ngIf="newSlot" (click)="createSlot1();" [disabled]="!manageRepeatFieldPermission" class="btn btn-default btn-outline-dark"> Save and Create New</button>
            <button *ngIf="newSlot" (click)="createSlot($event);" [disabled]="!manageRepeatFieldPermission" class="btn btn-default btn-outline-dark" style="float: right">Save</button>
            <button *ngIf="!newSlot" (click)="updateSlot();" [disabled]="!manageRepeatFieldPermission" class="btn btn-default btn-outline-dark">Update Repeat Field</button>


              <div *ngIf="missingSlot==true&&newSlot" style="color: red">&nbsp;{{missingSlotMessage}}</div>
              <div *ngIf="missingUpdate==true" style="color: red">&nbsp;{{missingUpdateMessage}}</div>
          </div>
          <!-- <button type="button" class="btn btn-outline-light btn-sm float-md-right m-4"
            >Create</button> -->

            </div>
            </div>
            </div>

            <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog"
            aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered " role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Are you sure you want to
                    delete the library?</h5>
                  <button type="button" (click)="dismissConfirm2($event);" class="close"
                    aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body ">
                  <button type="button" class="btn btn-secondary"
                    (click)="dismissConfirm2($event);">Go Back</button>
                  <button style="float:right" type="button" class="btn btn-primary"
                    (click)="dismissConfirm2($event); deleteLibrary(deleteUser, deleteIndex)">Delete</button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal fade" id="deleteModalPCA" tabindex="-1" role="dialog"
            aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered " role="document" style ="overflow: hidden">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Are you sure you want to
                    delete the cost library?</h5>
                  <button type="button" (click)="dismissConfirm5($event);" class="close"
                    aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body ">
                  <button type="button" class="btn btn-secondary"
                    (click)="dismissConfirm5($event);">Go Back</button>
                  <button style="float:right" type="button" class="btn btn-primary" [disabled]="!manageLibraryPermission"
                    (click)="dismissConfirm5($event); deleteCostLibrary(deleteUser, deleteIndex)">Delete</button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal fade" id="deleteModal2" tabindex="-1" role="dialog"
          aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered " role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Are you sure you want to
                  delete the Repeat Field?</h5>
                <button type="button" (click)="dismissConfirm1($event);" class="close"
                  aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body ">
                <button type="button" class="btn btn-secondary"
                  (click)="dismissConfirm1($event);">Go Back</button>
                <button style="float:right" type="button" class="btn btn-primary"
                  (click)="dismissConfirm1($event); deleteSlot(slotToDelete, deleteSlotIndex)">Delete</button>
              </div>
            </div>
          </div>
        </div>
          <div class="modal fade" id="deleteTempConfirm" tabindex="-1" role="dialog"
          aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered " role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Are you sure you want to
                  delete the Template?</h5>
                <button type="button" (click)="dismissConfirm3($event);" class="close"
                  aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body ">
                <button type="button" class="btn btn-secondary"
                  (click)="dismissConfirm3($event);">Go Back</button>
                <button style="float:right" type="button" class="btn btn-primary"
                  (click)="dismissConfirm3($event); deleteTemplate()">Delete</button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade" id="deleteWatermarkConfirm" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered " role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title" id="exampleModalLabel">Are you sure you want to
                delete the Watermark?</h6>
              <button type="button" (click)="dismissConfirm('#deleteWatermarkConfirm');" class="close"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body ">
              <button type="button" class="btn btn-secondary"
                (click)="dismissConfirm('#deleteWatermarkConfirm');">Go Back</button>
              <button style="float:right" type="button" class="btn btn-primary"
                (click)="dismissConfirm('#deleteWatermarkConfirm'); deleteWatermark()">Delete</button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="copyWith" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered " role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title" id="exampleModalLabel">Copy With Repeat Fields?</h6>
              <button type="button" (click)="dismissConfirm4($event);" class="close"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body ">
              <button type="button" class="btn btn-secondary"
                (click)="dismissConfirm4($event); copyTemplate('N')">No</button>
              <button style="float:right" type="button" class="btn btn-primary"
                (click)="dismissConfirm4($event); copyTemplate('Y')">Yes</button>
            </div>
          </div>
        </div>
      </div>

  </section>
  <app-panel [header]="'Profile Management'" [opened]="showLogo" [align]="'right'" [fixed]="[-10, 54]"
    (didClosed)="showLogo = null">
    
    <ng-container name="body">
      
      <app-logo *ngIf="userInfo" class="w-100 h-100" [logoInfo]="logoInfo" [userInfo]='userInfo'
        (editReport)="onEditReport($event)" (logOut)='logOut()'></app-logo>
    </ng-container>
  </app-panel>
</div>

<!-- FOOTER: -->
<app-footer></app-footer>